(function () {
  "use strict";

if (window.Eurus && window.Eurus.loadedScript && window.Eurus.loadedScript.has("product-quote.js")) {
  return;
}

window.Eurus = window.Eurus || {};
window.Eurus.loadedScript = window.Eurus.loadedScript || new Set();
window.Eurus.loadedScript.add("product-quote.js");

/* =========================
   QUOTE POPUP - HORIZONTAL DESIGN + SWIPER PROGRESS BAR
========================= */
let quoteBasketSwiper = null;

function createQuoteInstanceId() {
  return `quote_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

function ensureQuoteItemInstanceId(item) {
  if (!item) return "";
  item.properties = item.properties || {};

  if (!item.properties._quote_instance_id) {
    item.properties._quote_instance_id = createQuoteInstanceId();
  }

  return item.properties._quote_instance_id;
}

function getQuotePopup() {
  return document.getElementById("quotePopup");
}

function getQuoteBox() {
  return document.getElementById("quoteBox");
}

function getQuoteItemKey(item) {
  if (!item) return "";
  const properties = item.properties || {};

  return [
    item.variant_id || "",
    normalizeOptions(item.options || {}),
    normalizeProperties(properties),
    properties._parent_quote_key || "",
    properties._parent_variant_id || ""
  ].join("_");
}

function getQuoteStorageItemKey(item) {
  if (!item) return "";
  const instanceId = item.properties && item.properties._quote_instance_id;
  if (instanceId) return String(instanceId);

  return [
    item.variant_id || "",
    JSON.stringify(item.options || {}),
    JSON.stringify(item.properties || {})
  ].join("_");
}

function getLinkedParentQuoteKey(item) {
  return cleanText(item && item.properties && item.properties._parent_quote_key);
}

function getLinkedParentStorageKey(item) {
  return cleanText(item && item.properties && item.properties._parent_storage_key);
}

function isLinkedQuoteItem(item) {
  return !!(getLinkedParentQuoteKey(item) || getLinkedParentStorageKey(item) || (item && item.properties && item.properties._parent_variant_id));
}

function findLinkedParentIndex(items, item) {
  const parentQuoteKey = getLinkedParentQuoteKey(item);
  const parentStorageKey = getLinkedParentStorageKey(item);
  const parentVariantId = item && item.properties && item.properties._parent_variant_id;

  return items.findIndex((candidate) => {
    if (!candidate || isLinkedQuoteItem(candidate)) return false;
    if (parentQuoteKey && getQuoteItemKey(candidate) === parentQuoteKey) return true;
    if (parentStorageKey && getQuoteStorageItemKey(candidate) === parentStorageKey) return true;
    return parentVariantId && String(candidate.variant_id) === String(parentVariantId);
  });
}

function getLinkedChildIndexes(items, parentItem) {
  const parentQuoteKey = getQuoteItemKey(parentItem);
  const parentVariantId = parentItem && parentItem.variant_id;

  return items.reduce((indexes, item, index) => {
    if (!isLinkedQuoteItem(item)) return indexes;

    const itemParentQuoteKey = getLinkedParentQuoteKey(item);
    const itemParentStorageKey = getLinkedParentStorageKey(item);
    const itemParentVariantId = item && item.properties && item.properties._parent_variant_id;

    if (
      (itemParentQuoteKey && itemParentQuoteKey === parentQuoteKey) ||
      (itemParentStorageKey && itemParentStorageKey === getQuoteStorageItemKey(parentItem)) ||
      (!itemParentQuoteKey && !itemParentStorageKey && itemParentVariantId && String(itemParentVariantId) === String(parentVariantId))
    ) {
      indexes.push(index);
    }

    return indexes;
  }, []);
}

function updateQuoteItemQuantity(items, index, delta) {
  const item = items[index];
  if (!item) return items;

  const parentIndex = isLinkedQuoteItem(item) ? findLinkedParentIndex(items, item) : index;

  if (parentIndex === -1) {
    item.qty = (Number(item.qty) || 1) + delta;
    return item.qty <= 0 ? items.filter((_, itemIndex) => itemIndex !== index) : items;
  }

  const parentItem = items[parentIndex];
  const nextQuantity = (Number(parentItem.qty) || 1) + delta;
  const childIndexes = getLinkedChildIndexes(items, parentItem);
  const relatedIndexes = new Set([parentIndex, ...childIndexes]);

  if (nextQuantity <= 0) {
    return items.filter((_, itemIndex) => !relatedIndexes.has(itemIndex));
  }

  parentItem.qty = nextQuantity;
  childIndexes.forEach((childIndex) => {
    if (items[childIndex]) {
      items[childIndex].qty = nextQuantity;
    }
  });

  return items;
}

function removeQuoteItem(items, index) {
  const item = items[index];
  if (!item) return items;
  const instanceId = ensureQuoteItemInstanceId(item);

  const parentIndex = isLinkedQuoteItem(item) ? findLinkedParentIndex(items, item) : index;

  if (parentIndex === -1) {
    return items.filter((candidate, itemIndex) => {
      const candidateInstanceId = candidate && candidate.properties && candidate.properties._quote_instance_id;
      return instanceId ? candidateInstanceId !== instanceId : itemIndex !== index;
    });
  }

  const parentItem = items[parentIndex];
  const relatedIndexes = new Set([parentIndex, ...getLinkedChildIndexes(items, parentItem)]);

  return items.filter((_, itemIndex) => !relatedIndexes.has(itemIndex));
}

function getQuoteRemoveIconHtml() {
  const template = document.getElementById("QuotePopupRemoveIcon");
  return template ? template.innerHTML : "Remove";
}

function consolidateQuoteItems(items) {
  if (!Array.isArray(items)) return [];

  const grouped = new Map();

  items.forEach((item) => {
    if (!item || !item.variant_id) return;

    const normalizedItem = {
      ...item,
      qty: Math.max(1, Number(item.qty || 1) || 1),
      options: item.options || {},
      properties: item.properties || {}
    };
    ensureQuoteItemInstanceId(normalizedItem);

    const key = getQuoteItemKey(normalizedItem);

    if (!key) return;

    if (!grouped.has(key)) {
      grouped.set(key, normalizedItem);
      return;
    }

    const existingItem = grouped.get(key);
    existingItem.qty = (Number(existingItem.qty || 0) || 0) + normalizedItem.qty;

    if (!existingItem.image && normalizedItem.image) {
      existingItem.image = normalizedItem.image;
    }

    if (!existingItem.color_swatch && normalizedItem.color_swatch) {
      existingItem.color_swatch = normalizedItem.color_swatch;
    }

    if (!existingItem.color_swatches && normalizedItem.color_swatches) {
      existingItem.color_swatches = normalizedItem.color_swatches;
    }

    if (!existingItem.texture_swatches && normalizedItem.texture_swatches) {
      existingItem.texture_swatches = normalizedItem.texture_swatches;
    }
  });

  return Array.from(grouped.values());
}

/* =========================
   SAFE LOCAL STORAGE
========================= */
function getQuoteItems() {
  try {
    const items = JSON.parse(localStorage.getItem("quoteItems"));
    let changed = false;
    const normalizedItems = (Array.isArray(items) ? items : []).map((item) => {
      if (!item) return item;
      const instanceIdBefore = item.properties && item.properties._quote_instance_id;
      ensureQuoteItemInstanceId(item);
      if (!instanceIdBefore) changed = true;
      if (!item.variant_title) return item;

      const formattedTitle = getCustomDimensionVariantTitle(
        item.properties || {},
        item.variant_title
      );
      const dimensionSummary = normalizeCustomDimensionSummary(cleanText(item.properties && item.properties._custom_dimensions_summary)) ||
        getCustomDimensionSummary(item.properties || {}, item.variant_title);
      if (formattedTitle === cleanText(item.variant_title) && dimensionSummary === cleanText(item.custom_dimensions_summary)) return item;

      changed = true;
      return { ...item, variant_title: formattedTitle, custom_dimensions_summary: dimensionSummary };
    });

    if (changed) {
      localStorage.setItem("quoteItems", JSON.stringify(normalizedItems));
    }

    return consolidateQuoteItems(sanitizeQuoteItemsFinishProperties(normalizedItems));
  } catch (e) {
    console.warn("Quote items parse error", e);
    return [];
  }
}

function setQuoteItems(items) {
  localStorage.setItem("quoteItems", JSON.stringify(consolidateQuoteItems(sanitizeQuoteItemsFinishProperties(items || []))));
}

function normalizeQuoteFinishKey(key) {
  return cleanText(key).toLowerCase().replace(/[^a-z0-9]+/g, "");
}

function isCustomModificationKey(key) {
  const cleanKey = cleanText(key)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

  return [
    "custom_wood_color",
    "request_custom_wood_color",
    "other_wood_species",
    "custom_wood_species",
    "request_custom_wood_species",
    "custom_color",
    "request_custom_color",
    "custom_gfrc_texture",
    "other_gfrc_textures",
    "custom_frp_texture",
    "other_frp_textures"
  ].indexOf(cleanKey) !== -1;
}

function isWoodKey(key) {
  if (isCustomModificationKey(key)) return false;
  const cleanKey = normalizeQuoteFinishKey(key);
  return cleanKey === "wood" || cleanKey === "selectwood";
}

function isPowderCoatOrWoodKey(key) {
  return isPowderCoatKey(key) || isWoodKey(key);
}

function isPowderCoatKey(key) {
  const cleanKey = normalizeQuoteFinishKey(key);

  return cleanKey === "powdercoat" || cleanKey === "selectpowdercoat";
}

function isPowderCoatOrWoodDecisionKey(key) {
  if (isCustomModificationKey(key)) return false;

  const cleanKey = normalizeQuoteFinishKey(key);
  return isPowderCoatKey(key) ||
    isWoodKey(key) ||
    cleanKey === "woodtexture" ||
    cleanKey === "selectwoodtexture" ||
    cleanKey === "powdercoattexture" ||
    cleanKey === "selectpowdercoattexture";
}

function sanitizeQuoteItemFinishProperties(item) {
  if (!item || !item.properties) return item;

  const hasFinish = Object.entries(item.properties).some(([key, value]) => {
    return cleanText(value) && isPowderCoatKey(key);
  });

  if (hasFinish) {
    Object.keys(item.properties).forEach((key) => {
      if (isColorTextureSummaryKey(key)) {
        delete item.properties[key];
      }
    });
  }

  return item;
}

function sanitizeQuoteItemsFinishProperties(items) {
  return (items || []).map(sanitizeQuoteItemFinishProperties);
}

function sanitizeFinishProperties(properties) {
  const sanitized = { ...(properties || {}) };
  const hasFinish = Object.entries(sanitized).some(([key, value]) => {
    return cleanText(value) && isPowderCoatKey(key);
  });

  if (hasFinish) {
    Object.keys(sanitized).forEach((key) => {
      if (isColorTextureSummaryKey(key)) {
        delete sanitized[key];
      }
    });
  }

  return sanitized;
}

/* =========================
   HEADER TOGGLE
========================= */
document.addEventListener("click", (event) => {
  const toggleBar = event.target.closest("#quoteToggle");
  if (!toggleBar || event.target.closest("a, button")) return;

  const quoteBox = getQuoteBox();
  if (!quoteBox) return;
  quoteBox.classList.toggle("collapsed");

  if (!quoteBox.classList.contains("collapsed")) {
    renderQuoteBasket();
    if (typeof updateQuoteSwiper === "function") {
      setTimeout(updateQuoteSwiper, 50);
    }
  }
});

/* =========================
   CLOSE
========================= */
document.addEventListener("click", (event) => {
  if (!event.target.closest("[data-quote-close]")) return;

  event.preventDefault();
  event.stopPropagation();

  const quoteBox = getQuoteBox();
  if (!quoteBox) return;
  quoteBox.classList.toggle("collapsed");

  if (!quoteBox.classList.contains("collapsed")) {
    renderQuoteBasket();
    if (typeof updateQuoteSwiper === "function") {
      setTimeout(updateQuoteSwiper, 50);
    }
  }
});

/* =========================
   OPEN
========================= */
function openQuote() {
  const quotePopup = getQuotePopup();
  const quoteBox = getQuoteBox();

  if (!quotePopup || !quoteBox) return;

  quotePopup.classList.remove("hidden");
  quotePopup.style.display = "block";
  quotePopup.classList.add("block__quote-popup-open");
  quoteBox.classList.remove("collapsed");
  renderQuoteBasket();
  if (typeof updateQuoteSwiper === "function") {
    setTimeout(updateQuoteSwiper, 50);
  }
}

/* =========================
   UPDATE COUNT
========================= */
function updateQuoteCount() {
  const items = getQuoteItems();
  const totalQty = items.reduce((total, item) => total + Number(item.qty || 0), 0);
  const quotePopup = getQuotePopup();

  document.querySelectorAll(".quote-count").forEach((el) => {
    el.textContent = totalQty;
  });

  document.querySelectorAll("[data-quote-count-label]").forEach((el) => {
    el.innerHTML = `<span class="quote-count">${totalQty}</span> ${totalQty === 1 ? "item" : "items"}`;
  });

  if (quotePopup) {
    if (items.length > 0) {
      quotePopup.classList.remove("hidden");
      quotePopup.style.display = "block";
      quotePopup.classList.add("block__quote-popup-open");
    } else {
      quotePopup.classList.add("hidden");
      quotePopup.style.display = "none";
      quotePopup.classList.remove("block__quote-popup-open");
    }
  }
}

/* =========================
   NORMALIZE OPTIONS
========================= */
function normalizeOptions(options) {
  if (!options) return "";

  return Object.entries(options)
    .map(([k, v]) => `${String(k).toLowerCase()}:${String(v).toLowerCase()}`)
    .sort()
    .join("|");
}

/* =========================
   NORMALIZE PROPERTIES
========================= */
function normalizeProperties(properties) {
  if (!properties) return "";

  const entries = Object.entries(properties).filter(([k, v]) => {
    const cleanKey = String(k || "").trim();
    const cleanValue = cleanText(v);

    if (!cleanKey || !cleanValue) return false;
    if (cleanKey.startsWith("_") && cleanKey !== "_quote_signature") return false;

    return true;
  });

  const hasCombinedColorTexture = entries.some(([k]) => isColorTextureSummaryKey(k));

  return entries
    .filter(([k]) => {
      const cleanKey = String(k || "").trim();

      if (hasCombinedColorTexture && (isColorKey(cleanKey) || isTextureKey(cleanKey))) {
        return !isColorKey(cleanKey) && !isTextureKey(cleanKey);
      }

      return true;
    })
    .map(([k, v]) => `${String(k).toLowerCase()}:${String(v).toLowerCase()}`)
    .sort()
    .join("|");
}

function buildQuoteSelectionSignature(options, properties, imageUrl) {
  const cleanImage = normalizeImageUrl(imageUrl || "");
  const visibleProperties = Object.entries(properties || {})
    .filter(([key, value]) => {
      const cleanKey = String(key || "").trim();
      const cleanValue = cleanText(value);

      return !!cleanKey && !!cleanValue && !cleanKey.startsWith("_");
    })
    .map(([key, value]) => `${String(key).toLowerCase()}:${cleanText(value).toLowerCase()}`)
    .sort()
    .join("|");

  return [normalizeOptions(options || {}), visibleProperties, cleanImage].join("||");
}

function removeQuoteOptionSnapshotProperties(properties) {
  const cleaned = { ...(properties || {}) };

  Object.keys(cleaned).forEach((key) => {
    const cleanKey = cleanText(key);

    if (
      isColorKey(cleanKey) ||
      isTextureKey(cleanKey) ||
      isColorTextureSummaryKey(cleanKey) ||
      isGenericGroupedColorTextureLabel(cleanKey)
    ) {
      delete cleaned[key];
    }
  });

  return cleaned;
}

function isCustomDimensionKey(key) {
  const normalizedKey = cleanText(key)
    .toLowerCase()
    .replace(/^_+/, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

  return normalizedKey === "custom_dimensions_summary" ||
    normalizedKey === "custom_length" ||
    normalizedKey === "custom_width" ||
    normalizedKey === "custom_height" ||
    normalizedKey === "custom_diameter" ||
    normalizedKey === "custom_depth";
}

function removeQuoteVariantOptionProperties(properties, options, variantTitle) {
  const cleaned = { ...(properties || {}) };
  const optionValueMarkers = new Set();
  const cleanVariantTitle = cleanText(variantTitle).toLowerCase();

  Object.values(options || {}).forEach((value) => {
    const cleanValue = cleanText(value).toLowerCase();
    if (cleanValue && cleanValue !== "default title") {
      optionValueMarkers.add(cleanValue);
    }
  });

  Object.keys(cleaned).forEach((key) => {
    const cleanKey = cleanText(key);
    const cleanValue = cleanText(cleaned[key]);
    const cleanValueLower = cleanValue.toLowerCase();

    if (!cleanKey || !cleanValue) return;
    if (cleanKey.charAt(0) === "_") return;
    if (isCustomDimensionKey(cleanKey)) return;

    if (
      optionValueMarkers.has(cleanValueLower) ||
      (cleanVariantTitle && cleanValueLower && cleanVariantTitle.indexOf(cleanValueLower) !== -1)
    ) {
      delete cleaned[key];
    }
  });

  return cleaned;
}

/* =========================
   ESCAPE HTML
========================= */
function escapeHtml(str) {
  if (str === null || str === undefined) return "";

  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

/* =========================
   CLEAN TEXT
========================= */
function cleanText(str) {
  return String(str || "")
    .replace(/\s+/g, " ")
    .replace(/[:*]+$/g, "")
    .trim();
}

function getDisplayVariantTitle(item) {
  const variantTitle = cleanText(item && (item.variant_title || item.variant));

  if (variantTitle && variantTitle.toLowerCase() !== "default title") {
    return variantTitle;
  }

  return "";
}

function formatNumericVariantDimensions(value) {
  const parts = cleanText(value).split(/\s*(?:\/|x)\s*/i);
  if (parts.length !== 3) return cleanText(value);

  const values = parts.map((part) => {
    const match = cleanText(part).match(/^\d+(?:\.\d+)?/);
    return match ? match[0] : "";
  });

  if (values.some((part) => !part)) return cleanText(value);

  return values.map((part, index) => `${part}"${['L', 'W', 'H'][index]}`).join(" / ");
}

function getCustomDimensionVariantTitle(properties, fallbackTitle) {
  const hasDiameter = Object.keys(properties || {}).some((k) => /diameter/i.test(k));
  const hasLengthOrWidth = Object.keys(properties || {}).some((k) => /length|width/i.test(k));

  const definitions = [
    { keys: ['custom_diameter', 'custom_height'], labels: ['Dia.', 'H'], pattern: /diameter/i },
    { keys: ['custom_length', 'custom_width', 'custom_height'], labels: ['L', 'W', 'H'], pattern: /length|width/i }
  ];
  const fallback = cleanText(fallbackTitle);
  const definition = hasLengthOrWidth
    ? definitions[1]
    : hasDiameter
    ? definitions[0]
    : (definitions.find((candidate) => candidate.pattern.test(fallback)) || definitions[0]);

  const values = definition.keys.map((key) => {
    const entry = Object.entries(properties || {}).find(([propertyKey, value]) => {
      const canonicalKey = getQuoteDetailCanonicalKey(propertyKey).replace(/\s+/g, '_');
      return canonicalKey === key && cleanText(value);
    });
    return entry ? cleanText(entry[1]).match(/^\d+(?:\.\d+)?/)?.[0] || '' : '';
  });

  if (values.every(Boolean)) {
    return values.map((value, index) => `${value}"${definition.labels[index]}`).join(' / ');
  }

  return formatNumericVariantDimensions(fallbackTitle);
}

function getCustomDimensionSummary(properties, fallbackTitle) {
  const title = getCustomDimensionVariantTitle(properties, fallbackTitle);

  return /^(?:\d+(?:\.\d+)?"L\s*\/\s*\d+(?:\.\d+)?"W\s*\/\s*\d+(?:\.\d+)?"H|\d+(?:\.\d+)?"Dia\.?\s*\/\s*\d+(?:\.\d+)?"H)$/i.test(title)
    ? title
    : "";
}

function normalizeCustomDimensionSummary(value) {
  const cleanValue = cleanText(value);
  const formattedValue = formatNumericVariantDimensions(cleanValue);

  return /^(?:\d+(?:\.\d+)?"L\s*\/\s*\d+(?:\.\d+)?"W\s*\/\s*\d+(?:\.\d+)?"H|\d+(?:\.\d+)?"Dia\.?\s*\/\s*\d+(?:\.\d+)?"H)$/i.test(formattedValue)
    ? formattedValue
    : cleanValue;
}

function setCustomDimensionProperty(properties, fallbackTitle) {
  const summary = getCustomDimensionSummary(properties, fallbackTitle);

  if (summary) {
    properties._custom_dimensions_summary = summary;
  } else {
    delete properties._custom_dimensions_summary;
  }

  return summary;
}

/* =========================
   CSS ESCAPE HELPER
========================= */
function quoteCssEscape(value) {
  if (window.CSS && typeof window.CSS.escape === "function") {
    return window.CSS.escape(value);
  }

  return String(value || "").replace(/["\\]/g, "\\$&");
}

/* =========================
   ADD PROPERTY SAFELY
========================= */
function addQuoteProperty(properties, key, value) {
  const cleanKey = cleanText(key);
  const cleanValue = cleanText(value);

  if (!cleanKey || !cleanValue) return;

  if (
    cleanValue.toLowerCase() === "default title" ||
    cleanValue.toLowerCase() === "select" ||
    cleanValue.toLowerCase() === "choose"
  ) {
    return;
  }

  properties[cleanKey] = cleanValue;
}

function addQuotePropertyValue(properties, key, value) {
  const cleanKey = cleanText(key);
  const cleanValue = cleanText(value);

  if (!cleanKey || !cleanValue) return;

  if (!properties[cleanKey]) {
    addQuoteProperty(properties, cleanKey, cleanValue);
    return;
  }

  const existingValues = String(properties[cleanKey])
    .split(",")
    .map((part) => cleanText(part))
    .filter(Boolean);

  if (existingValues.some((existingValue) => existingValue.toLowerCase() === cleanValue.toLowerCase())) return;

  properties[cleanKey] = existingValues.concat(cleanValue).join(", ");
}

function sanitizeSubmittedLineItemProperties(properties) {
  const sourceEntries = Object.entries(properties || {});
  const sanitized = {};
  const addedCanonicalKeys = new Set();
  let colorValue = "";
  let textureValue = "";
  let colorTextureSummary = "";
  let selectWoodValue = "";
  let selectedFinishValue = "";
  const getSubmittedCanonicalKey = (key) => {
    const normalized = cleanText(key)
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");

    if (
      normalized === "drainage" ||
      normalized === "drain_hole" ||
      normalized === "drain_holes" ||
      normalized === "drainhole" ||
      normalized === "drainholes" ||
      normalized === "drainage_holes" ||
      normalized === "select_drainage_holes" ||
      normalized === "select_drain_hole" ||
      normalized === "select_drainhole"
    ) {
      return "drainage_holes";
    }

    if (
      normalized === "irrigation" ||
      normalized === "irrigation_insert" ||
      normalized === "irrigation_system" ||
      normalized === "container_irrigation"
    ) {
      return "irrigation";
    }

    return normalized;
  };

  sourceEntries.forEach(([key, value]) => {
    const cleanKey = cleanText(key);
    const cleanValue = cleanText(value);

    if (!cleanKey || !cleanValue) return;

    const lowerKey = cleanKey.toLowerCase();
    const canonicalKey = getSubmittedCanonicalKey(cleanKey);

    if (lowerKey === "custom color" || lowerKey === "custom colour") {
      if (addedCanonicalKeys.has(canonicalKey)) return;
      sanitized[cleanKey] = cleanValue;
      addedCanonicalKeys.add(canonicalKey);
      return;
    }

    if (canonicalKey === "irrigation") {
      if (addedCanonicalKeys.has(canonicalKey)) return;
      sanitized["Irrigation System"] = cleanValue;
      addedCanonicalKeys.add(canonicalKey);
      return;
    }

    if (isColorTextureSummaryKey(cleanKey)) {
      colorTextureSummary = normalizeColorTextureTbdSummary(cleanValue);
      return;
    }

    if (lowerKey === "select wood" || lowerKey === "wood") {
      selectWoodValue = cleanValue;
      sanitized["Wood"] = cleanValue;
      addedCanonicalKeys.add("wood");
      return;
    }

    if (lowerKey === "powder-coat" || lowerKey === "powder coat" || lowerKey === "select powder coat") {
      selectedFinishValue = cleanValue;
      sanitized["Powder-Coat"] = cleanValue;
      addedCanonicalKeys.add("powder_coat");
      return;
    }

    if (!colorValue && isColorKey(cleanKey) && cleanValue.toLowerCase() !== "decide later") {
      colorValue = cleanValue;
    }

    if (!textureValue && isTextureKey(cleanKey)) {
      textureValue = cleanValue;
    }

    if (
      isColorKey(cleanKey) ||
      isTextureKey(cleanKey) ||
      isGenericGroupedColorTextureLabel(cleanKey)
    ) {
      return;
    }

    if (addedCanonicalKeys.has(canonicalKey)) return;

    if (canonicalKey === "drainage_holes") {
      sanitized["Drainage Holes"] = cleanValue;
      addedCanonicalKeys.add(canonicalKey);
      return;
    }

    if (canonicalKey === "irrigation") {
      sanitized["Irrigation"] = cleanValue;
      addedCanonicalKeys.add(canonicalKey);
      return;
    }

    sanitized[cleanKey] = cleanValue;
    addedCanonicalKeys.add(canonicalKey);
  });

  if (!colorTextureSummary && !selectedFinishValue) {
    if (colorValue && textureValue) {
      colorTextureSummary = buildColorTextureSummary(colorValue, textureValue);
    } else if (colorValue) {
      colorTextureSummary = colorValue;
    } else if (textureValue) {
      colorTextureSummary = textureValue;
    }
  }

  if (
    colorTextureSummary &&
    selectWoodValue &&
    colorTextureSummary.toLowerCase() === selectWoodValue.toLowerCase()
  ) {
    colorTextureSummary = "";
  }

  if (colorTextureSummary && !selectedFinishValue) {
    sanitized["Color & Texture"] = normalizeColorTextureTbdSummary(colorTextureSummary);
  }

  if (selectWoodValue) {
    sanitized["Wood"] = selectWoodValue;
  }

  return sanitized;
}

function normalizePropertyOrderKey(value) {
  return cleanText(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function getPropertyOrderCandidates(key) {
  const cleanKey = normalizePropertyOrderKey(key);
  if (!cleanKey) return [];

  const candidates = [cleanKey];

  if (cleanKey.indexOf("select_") === 0) {
    candidates.push(cleanKey.replace(/^select_/, ""));
  } else {
    candidates.push("select_" + cleanKey);
  }

  candidates.push(cleanKey.replace(/_insert$/, ""));
  candidates.push(cleanKey.replace(/_system$/, ""));
  candidates.push(cleanKey.replace(/_holes$/, ""));
  candidates.push(cleanKey.replace(/^request_/, ""));

  return candidates.filter((candidate, index, list) => candidate && list.indexOf(candidate) === index);
}

function getCurrentCustomOptionOrder() {
  const breakdown = document.querySelector("[data-price-breakdown][data-option-ranking]");
  const orderSource =
    (breakdown && breakdown.getAttribute("data-option-ranking")) ||
    getPropertyValueByName("properties[_custom_option_order]");

  return getCustomOptionOrderFromSource(orderSource);
}

function getCustomOptionOrderFromSource(orderSource) {
  const configuredOrder = String(orderSource || "")
    .split("|")
    .map(normalizePropertyOrderKey)
    .filter(Boolean);

  if (configuredOrder.length) return configuredOrder;

  return [
    "select_product_material",
    "select_shape",
    "select_color",
    "color_texture",
    "choose_1_of_5_gfrc_textures",
    "gfrc_texture",
    "choose_1_of_3_frp_textures",
    "frp_texture",
    "pre_weathering_finish",
    "powder_coat",
    "select_powder_coat",
    "wood",
    "select_wood",
    "irrigation",
    "irrigation_insert",
    "irrigation_system",
    "select_drainage_holes",
    "drainage_holes"
  ];
}

function getPropertyRank(key, order) {
  const candidates = getPropertyOrderCandidates(key);
  let rank = -1;

  candidates.some((candidate) => {
    rank = order.indexOf(candidate);
    return rank !== -1;
  });

  return rank;
}

function sortSubmittedLineItemProperties(properties) {
  const order = getCurrentCustomOptionOrder();
  if (!order.length) return properties || {};

  return Object.fromEntries(
    Object.entries(properties || {}).sort(([keyA], [keyB]) => {
      const rankA = getPropertyRank(keyA, order);
      const rankB = getPropertyRank(keyB, order);

      if (rankA !== -1 || rankB !== -1) {
        if (rankA === -1) return 1;
        if (rankB === -1) return -1;
        if (rankA !== rankB) return rankA - rankB;
      }

      return 0;
    })
  );
}

function mergeKnownHiddenPropertyFallbacks(properties) {
  const merged = { ...(properties || {}) };
  const hiddenFallbacks = [
    { id: "prop_color_texture", name: "properties[Color & Texture]" },
    { id: "prop_finish", name: "properties[Pre Weathering Finish]" },
    { id: "prop_select_wood", name: "properties[Wood]" },
    { id: "prop_material", name: "properties[Material]" },
    { id: "prop_shape", name: "properties[Select Shape]" }
  ];

  hiddenFallbacks.forEach(({ id, name }) => {
    const input = getHiddenInput(id, name);
    if (!input) return;

    const key = getPropertyKeyFromField(input);
    const value = getFieldPropertyValue(input);

    if (!key || !value) return;

    addQuoteProperty(merged, key, value);
  });

  return merged;
}

/* =========================
   QUOTE HIDDEN LINE ITEM PROPERTIES
   Keep this in quote-popup.js and remove the old separate hidden-properties script.
========================= */
function getForm() {
  if (window.CustomQuoteActiveForm && window.CustomQuoteActiveForm.isConnected) {
    return window.CustomQuoteActiveForm;
  }

  const propInfo = document.querySelector('form[data-type="add-to-cart-form"] .prop-info');
  if (propInfo && propInfo.closest) {
    const form = propInfo.closest('form');
    if (form) return form;
  }

  return document.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[action*="/cart/add"]');
}

function setActiveQuoteFormFromElement(element) {
  if (!element || !element.closest) return null;

  const productInfo = element.closest(".product-info");
  const form = productInfo && productInfo.querySelector(
    'form[data-type="add-to-cart-form"], form[action*="/cart/add"]'
  );

  if (form) {
    window.CustomQuoteActiveForm = form;
  }

  return form || null;
}

function getHiddenInput(id, name) {
  const form = getForm();
  let input = null;

  if (form) {
    // Use an attribute selector rather than `#id`: several hidden property
    // inputs share the same id across duplicated form instances (e.g. the
    // quick-view modal vs. the main product form), which is invalid HTML.
    // Browsers resolve `#id` selectors via a document-wide id lookup that
    // only tracks the first matching element, so a scoped `form.querySelector`
    // can wrongly return null (or the global fallback below can wrongly
    // grab the other instance) even when the correct element is a descendant
    // of `form`. The attribute-selector form does a real scoped subtree
    // search and isn't affected by that.
    input = form.querySelector(`[id="${String(id).replace(/"/g, '\\"')}"]`);

    if (!input && name) {
      input = form.querySelector(`input[type="hidden"][name="${name.replace(/"/g, '\\"')}"]`);
    }
  }

  if (!input) {
    input = document.getElementById(id);
  }

  if (!input && form) {
    input = document.createElement("input");
    input.type = "hidden";
    input.id = id;
    input.name = name;
    input.value = "";

    const target = form.querySelector(".prop-info") || form;
    target.appendChild(input);
  }

  return input;
}

function setHiddenValue(id, name, value) {
  const input = getHiddenInput(id, name);
  if (!input) return;

  if (name) {
    input.name = name;
  }

  input.value = cleanText(value);

  if (id === "prop_color_texture") {
    input.disabled = true;
  }
}

function setHiddenDisabled(id, name, disabled) {
  const input = getHiddenInput(id, name);
  if (!input) return;
  if (name) {
    input.name = name;
  }
  input.disabled = !!disabled;
}

function toHiddenPropertyId(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "") || "property";
}

function getCheckedValue(selector) {
  const input = document.querySelector(selector + ":checked");
  return input ? cleanText(input.value) : "";
}

function getCheckedValueByScope(scope, selector) {
  const root = scope && typeof scope.querySelector === "function" ? scope : document;
  const input = root.querySelector(selector + ":checked");
  return input ? cleanText(input.value) : "";
}

function getQuoteScope() {
  const form = getForm();

  return (
    (form && form.closest && form.closest(".product-info")) ||
    form ||
    document
  );
}

function normalizeOptionTitleKey(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function getCustomOptionTitle(optionKey, fallbackName, scope) {
  const root = scope && typeof scope.querySelector === "function" ? scope : getQuoteScope();
  const mapSource =
    (root.querySelector("[data-custom-option-title-map]") || document.querySelector("[data-custom-option-title-map]"));
  const fallback = cleanText(fallbackName || optionKey);

  if (!mapSource) return fallback;

  const targetKey = normalizeOptionTitleKey(optionKey);
  const aliasMap = {
    drainage_holes: ["select_drainage_holes"],
    cut_length_shorter: ["select_cut_length_shorter"],
    cut_width_shorter: ["select_cut_width_shorter"],
    cut_height_shorter: ["select_cut_height_shorter"],
    scoops: ["select_scope", "select_scoop"],
    toe_kick: ["select_toe_kick"],
    casters: ["select_casters"],
    false_bottom: ["select_false_bottom"],
    bottom_reinforcement: ["select_bottom_reinforcement"],
    tie_downs: ["select_tie_downs"],
    tourneseal: ["select_tourneseal"]
  };
  const targetKeys = [targetKey].concat(aliasMap[targetKey] || []);
  const lines = String(mapSource.getAttribute("data-custom-option-title-map") || "")
    .replace(/\r?\n/g, ",")
    .split(",");

  for (const line of lines) {
    const parts = line.split("=");
    if (parts.length < 2) continue;

    const key = normalizeOptionTitleKey(parts.shift());
    const label = cleanText(parts.join("="));

    if (key && targetKeys.indexOf(key) !== -1 && label) return label;
  }

  return fallback;
}

function getCustomOptionTitleMap(scope) {
  const root = scope && typeof scope.querySelector === "function" ? scope : getQuoteScope();
  const mapSource =
    (root.querySelector("[data-custom-option-title-map]") || document.querySelector("[data-custom-option-title-map]"));

  return mapSource ? cleanText(mapSource.getAttribute("data-custom-option-title-map") || "") : "";
}

function getCustomOptionPropertyName(optionKey, fallbackName, scope) {
  return `properties[${getCustomOptionTitle(optionKey, fallbackName || optionKey, scope)}]`;
}

function getCheckedValueByOptionKey(optionKey, scope) {
  const root = scope && typeof scope.querySelector === "function" ? scope : getQuoteScope();
  const fieldset = root.querySelector('[data-option-key="' + optionKey + '"]');
  if (!fieldset) return "";

  const input = fieldset.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked, select, textarea');
  if (!input) return "";

  if ((input.type === "radio" || input.type === "checkbox") && !input.checked) {
    return "";
  }

  return cleanText(input.value);
}

function getSelectedColorForScope(scope, options = {}) {
  const root = scope && typeof scope.querySelector === "function" ? scope : document;
  const selectors = [
    '.color-option[data-custom-color-media]:checked',
    '.block-color-texture-card__color-fieldset .color-option:checked',
    '.block-color-texture-card__color-fieldset input[type="radio"]:checked'
  ];

  for (const selector of selectors) {
    const inputs = Array.from(root.querySelectorAll(selector));

    for (const input of inputs) {
      if (!input) continue;

      if (options.excludeWood) {
        const card = input.closest && input.closest("[data-color-texture-card]");
        const colorLabel = card ? cleanText(card.getAttribute("data-color-property-label")) : "";
        if (isWoodPropertyLabel(colorLabel)) continue;
      }

      const value = cleanText(
        input.getAttribute("data-option-value") ||
        input.getAttribute("data-value") ||
        input.value
      );

      if (value) return value;
    }
  }

  return "";
}

function getSelectedColor() {
  return (
    getSelectedColorForScope(document, { excludeWood: true }) ||
    getCheckedValueByOptionKey("select_color") ||
    getCheckedValue('[name="properties[Select Color]"]') ||
    getCheckedValue('[name="properties[Color]"]')
  );
}

function getSelectedColorSwatchData(scope) {
  const root = scope && typeof scope.querySelector === "function" ? scope : document;
  const input = root.querySelector(
    '.color-option[data-custom-color-media]:checked, ' +
      '.block-color-texture-card__color-fieldset .color-option:checked, ' +
      '.block-color-texture-card__color-fieldset input[type="radio"]:checked'
  );

  if (!input) return null;

  const label = input.id ? root.querySelector(`label[for="${quoteCssEscape(input.id)}"]`) || document.querySelector(`label[for="${quoteCssEscape(input.id)}"]`) : null;
  const image = label ? label.querySelector(".block-color-texture-card__swatch img, img") : null;
  const colorEl = label ? label.querySelector(".block-color-texture-card__swatch-color") : null;
  const imageUrl = getImageFromElement(image);
  const cssColor = cleanText(colorEl ? (colorEl.style.background || colorEl.style.backgroundColor || "") : "");
  const value = cleanText(
    input.getAttribute("data-option-value") ||
      input.getAttribute("data-value") ||
      input.value
  );

  if (!imageUrl && !cssColor) return null;

  return {
    value: value,
    image: imageUrl,
    color: cssColor
  };
}

function getSelectedColorSwatchMap(scope) {
  const root = scope && typeof scope.querySelector === "function" ? scope : document;
  const swatches = {};

  root.querySelectorAll(".block-color-texture-card").forEach((card) => {
    const input = card.querySelector(
      '.color-option[data-custom-color-media]:checked, ' +
        '.block-color-texture-card__color-fieldset .color-option:checked, ' +
        '.block-color-texture-card__color-fieldset input[type="radio"]:checked'
    );

    if (!input) return;

    const label = input.id ? card.querySelector(`label[for="${quoteCssEscape(input.id)}"]`) || document.querySelector(`label[for="${quoteCssEscape(input.id)}"]`) : null;
    const image = label ? label.querySelector(".block-color-texture-card__swatch img, img") : null;
    const colorEl = label ? label.querySelector(".block-color-texture-card__swatch-color") : null;
    const imageUrl = getImageFromElement(image);
    const cssColor = cleanText(colorEl ? (colorEl.style.background || colorEl.style.backgroundColor || "") : "");

    if (!imageUrl && !cssColor) return;

    const colorLabel = cleanText(card.getAttribute("data-color-property-label")) || "Color & Texture";
    const swatch = {
      value: cleanText(input.getAttribute("data-option-value") || input.getAttribute("data-value") || input.value),
      image: imageUrl,
      color: cssColor
    };

    swatches[colorLabel] = swatch;

    if (colorLabel.toLowerCase() === "select powder coat") {
      swatches["Select Powder Coat"] = swatch;
      swatches["Color & Texture"] = swatch;
    } else if (isWoodPropertyLabel(colorLabel)) {
      swatches["Select Wood"] = swatch;
      swatches["Wood"] = swatch;
    } else {
      swatches["Color & Texture"] = swatch;
    }
  });

  return swatches;
}

function getSelectedTextureData() {
  return getSelectedTextureDataForScope(document);
}

function getSelectedTextureDataForScope(scope) {
  const root = scope && typeof scope.querySelector === "function" ? scope : document;
  let textureInput = root.querySelector(".block-color-texture-card__texture-item.is-visible input:checked");
  const decideLaterInput = root.querySelector('[data-decide-later-input="true"]:checked');

  if (decideLaterInput) {
    const card = decideLaterInput.closest("[data-color-texture-card]");
    const groupType = cleanText(card && card.getAttribute("data-group-type")).toLowerCase();
    const groupMap = {
      metal: "powder-coat",
      powder: "powder-coat",
      "powder-coat": "powder-coat",
      powdercoat: "powder-coat",
      wood: "wood",
      color: "decide-later"
    };

    return {
      value: cleanText(decideLaterInput.value),
      group: groupMap[groupType] || "decide-later"
    };
  }

  if (!textureInput) {
    textureInput = root.querySelector(".color-dependent-option.is-visible input:checked");
  }

  if (!textureInput) {
    textureInput = root.querySelector(".color-dependent-option input:checked");
  }

  if (!textureInput) {
    return {
      value: "",
      group: ""
    };
  }

  const item = textureInput.closest(".block-color-texture-card__texture-item, .color-dependent-option");

  return {
    value: cleanText(textureInput.value),
    group: item ? cleanText(item.getAttribute("data-texture-group")) : ""
  };
}

function getSelectedTextureSwatchMap(scope) {
  const root = scope && typeof scope.querySelector === "function" ? scope : document;
  const swatches = {};

  root.querySelectorAll(".block-color-texture-card").forEach((card) => {
    const input = card.querySelector(
      ".block-color-texture-card__texture-item.is-visible input:checked, " +
        ".color-dependent-option.is-visible input:checked, " +
        ".color-dependent-option input:checked"
    );

    if (!input || input.matches('[data-decide-later-input="true"]')) return;

    const item = input.closest(".block-color-texture-card__texture-item, .color-dependent-option");
    const label = input.id ? card.querySelector(`label[for="${quoteCssEscape(input.id)}"]`) || document.querySelector(`label[for="${quoteCssEscape(input.id)}"]`) : null;
    const image = label ? label.querySelector(".block-color-texture-card__texture-img img, img") : null;
    const textureEl = label ? label.querySelector(".block-color-texture-card__texture-img") : null;
    const imageUrl = normalizeImageUrl(input.getAttribute("data-quote-image") || getImageFromElement(image));
    const cssColor = cleanText(textureEl ? (textureEl.style.background || textureEl.style.backgroundColor || "") : "");

    if (!imageUrl && !cssColor) return;

    const textureLabel = cleanText(input.getAttribute("data-texture-group-label") || (item ? item.getAttribute("data-texture-group-label") : "")) || cleanText(card.getAttribute("data-texture-property-label")) || "Texture";
    const swatch = {
      value: cleanText(input.getAttribute("data-option-value") || input.getAttribute("data-value") || input.value),
      image: imageUrl,
      color: cssColor
    };

    swatches[textureLabel] = swatch;
    swatches["Texture"] = swatch;
  });

  return swatches;
}

function hasTextureChoicesForScope(scope) {
  const root = scope && typeof scope.querySelector === "function" ? scope : document;

  return !!root.querySelector(
    ".block-color-texture-card__texture-item.is-visible input:not([disabled]), " +
    ".color-dependent-option.is-visible input:not([disabled]), " +
    '[data-decide-later-input="true"]:not([disabled])'
  );
}

function hasColorChoicesForScope(scope) {
  const root = scope && typeof scope.querySelector === "function" ? scope : document;

  return !!root.querySelector(
    '.block-color-texture-card__color-fieldset .color-option[data-custom-color-media]:not([disabled]), ' +
    '.block-color-texture-card__color-fieldset .color-option:checked'
  );
}

function buildColorTextureSummary(colorValue, textureValue) {
  const cleanColor = cleanText(colorValue);
  let cleanTexture = cleanText(textureValue);

  if (cleanTexture.toLowerCase() === "decide later") {
    return "Decide Later";
  }

  if (!cleanColor && !cleanTexture) return "";
  if (cleanColor === "Decide Later") {
    return "Decide Later";
  }
  /*
  if (cleanTexture.toLowerCase() === "tbd") {
    return cleanColor ? cleanText(cleanColor + ", TBD Texture") : "TBD Texture";
  }
  */
  if (cleanTexture.toLowerCase() === "tbd") return cleanColor;
  if (!cleanTexture) return cleanColor;
  if (!cleanColor) return cleanTexture;

  let texturePart = cleanTexture;
  const colorLower = cleanColor.toLowerCase();
  const textureLower = cleanTexture.toLowerCase();

  if (textureLower.startsWith(colorLower + " ")) {
    texturePart = cleanText(cleanTexture.slice(cleanColor.length));
  } else if (textureLower === colorLower) {
    texturePart = "";
  }

  if (!texturePart) {
    return cleanColor;
  }

  if (texturePart.toLowerCase().endsWith(" texture")) {
    return cleanText(cleanColor + ", " + texturePart);
  }

  return cleanText(cleanColor + ", " + texturePart + " Texture");
}

function normalizeColorTextureTbdSummary(value) {
  const cleanValue = cleanText(value);
  const match = cleanValue.match(/^(.+?)\s*-\s*decide later$/i);

  /*
  if (match && match[1]) {
    return cleanText(match[1] + ", TBD Texture");
  }

  if (/,\s*TBD Texture$/i.test(cleanValue)) {
    return cleanValue;
  }

  return cleanValue.replace(/\s+TBD Texture$/i, ", TBD Texture");
  */
  if (match && match[1]) {
    return "Decide Later";
  }

  if (/^(?:tbd|tbd texture)$/i.test(cleanValue) || /,?\s*TBD Texture$/i.test(cleanValue)) {
    return "Decide Later";
  }

  return cleanValue;
}

function isQuoteOnlyDecisionPlaceholder(value) {
  const normalizedValue = cleanText(value).toLowerCase();
  return normalizedValue === "decide later" || normalizedValue === "tbd" || normalizedValue === "tbd texture";
}

function isGenericGroupedColorTextureLabel(label) {
  const cleanLabel = cleanText(label).toLowerCase();

  return (
    cleanLabel === "color & texture" ||
    cleanLabel === "color and texture" ||
    cleanLabel === "color texture" ||
    cleanLabel === "color & texture texture" ||
    cleanLabel === "color and texture texture" ||
    cleanLabel === "color texture texture"
  );
}

function isWoodPropertyLabel(label) {
  const cleanLabel = cleanText(label)
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  return cleanLabel === "wood" || cleanLabel === "select wood" || cleanLabel.indexOf("wood") !== -1;
}

function buildCurrentColorTextureProperties(scope) {
  const properties = {};
  const root =
    (scope && scope.closest && (scope.closest(".product-info") || scope.closest("[data-section-id]"))) ||
    (scope && typeof scope.querySelector === "function" ? scope : document);

  const groupedCards = Array.from(
    (root && root.querySelectorAll ? root : document).querySelectorAll('[data-color-texture-card][data-grouped-color-texture="true"]')
  ).filter(isElementVisible);

  if (groupedCards.length) {
    groupedCards.forEach((card) => {
      const colorLabel = cleanText(card.getAttribute("data-color-property-label"));
      const colorValue = getSelectedColorForScope(card);
      const textureData = getSelectedTextureDataForScope(card);
      const textureValue = cleanText(textureData && textureData.value ? textureData.value : "");
      const textureGroup = cleanText(textureData && textureData.group ? textureData.group : "");
      const isWoodCard = isWoodPropertyLabel(colorLabel);
      const isPowderCoatCard = colorLabel.toLowerCase() === "select powder coat";
      const hasTextureChoices = hasTextureChoicesForScope(card);

      if (colorLabel && colorValue && !isWoodCard && !isGenericGroupedColorTextureLabel(colorLabel)) {
        properties[colorLabel] = colorValue;
      }

      if (colorLabel.toLowerCase() === "select powder coat" && colorValue) {
        properties["Powder-Coat"] = colorValue;
      }

      if (isWoodCard && colorValue) {
        properties["Wood"] = colorValue;
      }

      if (!colorValue && textureValue === "Decide Later") {
        if (isWoodCard) {
          properties["Wood"] = "Decide Later";
        } else if (isPowderCoatCard) {
          properties["Powder-Coat"] = "Decide Later";
        }
      }

      if (textureValue) {
        const quoteTextureValue = textureValue === "Decide Later" ? "Decide Later" : textureValue;

        if (textureGroup === "gfrc") {
          properties["GFRC Texture"] = quoteTextureValue;
        } else if (textureGroup === "frp") {
          properties["FRP Texture"] = quoteTextureValue;
        } else if (textureGroup === "pre-weathering") {
          properties["Pre Weathering Finish"] = quoteTextureValue;
        } else if (textureGroup === "powder-coat") {
          properties["Powder-Coat"] = quoteTextureValue;
        } else if (textureGroup === "wood") {
          properties["Wood Texture"] = quoteTextureValue;
        }

        if (!isWoodCard && !isPowderCoatCard && textureGroup !== "powder-coat") {
          properties["Color & Texture"] = buildColorTextureSummary(colorValue, quoteTextureValue);
        }
      } else if (colorValue && !isWoodCard && !isPowderCoatCard && !properties["Color & Texture"]) {
        properties["Color & Texture"] = hasTextureChoices
          ? buildColorTextureSummary(colorValue, "TBD")
          : colorValue;
      }
    });

    if (!properties["Color & Texture"] && !properties["Wood"] && !properties["Powder-Coat"]) {
      const fallbackColorValue = getSelectedColorForScope(root, { excludeWood: true });
      const fallbackTextureData = getSelectedTextureDataForScope(root);
      const fallbackTextureValue = cleanText(fallbackTextureData && fallbackTextureData.value ? fallbackTextureData.value : "");
      const fallbackTextureGroup = cleanText(fallbackTextureData && fallbackTextureData.group ? fallbackTextureData.group : "");
      const fallbackHasTextureChoices = hasTextureChoicesForScope(root);

      if (fallbackTextureValue) {
        const quoteTextureValue = fallbackTextureValue === "Decide Later" ? "Decide Later" : fallbackTextureValue;

        if (fallbackTextureGroup === "gfrc") {
          properties["GFRC Texture"] = quoteTextureValue;
        } else if (fallbackTextureGroup === "frp") {
          properties["FRP Texture"] = quoteTextureValue;
        } else if (fallbackTextureGroup === "pre-weathering") {
          properties["Pre Weathering Finish"] = quoteTextureValue;
        } else if (fallbackTextureGroup === "powder-coat") {
          properties["Powder-Coat"] = quoteTextureValue;
        } else if (fallbackTextureGroup === "wood") {
          properties["Wood Texture"] = quoteTextureValue;
        }

        if (fallbackTextureGroup !== "powder-coat") {
          properties["Color & Texture"] = fallbackColorValue
            ? buildColorTextureSummary(fallbackColorValue, quoteTextureValue)
            : quoteTextureValue;
        }
      } else if (fallbackColorValue) {
        properties["Color & Texture"] = fallbackHasTextureChoices
          ? buildColorTextureSummary(fallbackColorValue, "TBD")
          : fallbackColorValue;
      }
    }

    return properties;
  }

  const colorValue = getSelectedColorForScope(root, { excludeWood: true });
  const textureData = getSelectedTextureDataForScope(root);
  const textureValue = cleanText(textureData && textureData.value ? textureData.value : "");
  const textureGroup = cleanText(textureData && textureData.group ? textureData.group : "");
  const woodValue = getCheckedValueByScope(root, '[name="properties[Wood]"]') ||
    getCheckedValueByScope(root, '[name="properties[Select Wood]"]');
  const hasTextureChoices = hasTextureChoicesForScope(root);
  const hasColorChoices = hasColorChoicesForScope(root);
  const hasFinishSelection = textureGroup === "powder-coat";

  if (colorValue && textureGroup === "powder-coat") {
    properties["Powder-Coat"] = colorValue;
  }

  if (textureValue) {
    const quoteTextureValue = textureValue === "Decide Later" ? "Decide Later" : textureValue;

    if (textureGroup === "gfrc") {
      properties["GFRC Texture"] = quoteTextureValue;
    } else if (textureGroup === "frp") {
      properties["FRP Texture"] = quoteTextureValue;
    } else if (textureGroup === "pre-weathering") {
      properties["Pre Weathering Finish"] = quoteTextureValue;
    } else if (textureGroup === "powder-coat") {
      properties["Powder-Coat"] = quoteTextureValue;
    } else if (textureValue === "Decide Later") {
      properties["Texture"] = quoteTextureValue;
    }

    if (!hasFinishSelection) {
      properties["Color & Texture"] = buildColorTextureSummary(colorValue, quoteTextureValue);
    }
  } else if (colorValue && !hasFinishSelection) {
    properties["Color & Texture"] = hasTextureChoices
      ? buildColorTextureSummary(colorValue, "TBD")
      : colorValue;
  }

  if (woodValue) {
    properties["Wood"] = woodValue;
  }

  return properties;
}

function hasGroupedColorTextureCards() {
  return Array.from(document.querySelectorAll('[data-color-texture-card][data-grouped-color-texture="true"]')).some(isElementVisible);
}

function updateGroupedColorTextureProperties() {
  const colorPropertyName = getCustomOptionPropertyName("select_color", "Select Color");
  const gfrcTexturePropertyName = getCustomOptionPropertyName("choose_1_of_5_gfrc_textures", "GFRC Texture");
  const frpTexturePropertyName = getCustomOptionPropertyName("choose_1_of_3_frp_textures", "FRP Texture");
  const finishPropertyName = getCustomOptionPropertyName("pre_weathering_finish", "Pre Weathering Finish");
  const powderCoatPropertyName = getCustomOptionPropertyName("powder_coat", "Powder-Coat");
  const woodPropertyName = getCustomOptionPropertyName("select_wood", "Wood");
  const colorTexturePropertyName = getCustomOptionPropertyName("color_texture", "Color & Texture");

  setHiddenValue("prop_color", colorPropertyName, "");
  setHiddenValue("prop_gfrc_texture", gfrcTexturePropertyName, "");
  setHiddenValue("prop_frp_texture", frpTexturePropertyName, "");
  setHiddenValue("prop_finish", finishPropertyName, "");
  setHiddenValue("prop_powder_coat", powderCoatPropertyName, "");
  setHiddenValue("prop_select_powder_coat", powderCoatPropertyName, "");
  setHiddenValue("prop_select_wood", woodPropertyName, "");
  setHiddenValue("prop_color_texture", colorTexturePropertyName, "");

  setHiddenDisabled("prop_color", colorPropertyName, false);
  setHiddenDisabled("prop_gfrc_texture", gfrcTexturePropertyName, false);
  setHiddenDisabled("prop_frp_texture", frpTexturePropertyName, false);
  setHiddenDisabled("prop_finish", finishPropertyName, false);
  setHiddenDisabled("prop_powder_coat", powderCoatPropertyName, false);
  setHiddenDisabled("prop_select_powder_coat", powderCoatPropertyName, false);
  setHiddenDisabled("prop_select_wood", woodPropertyName, false);
  setHiddenDisabled("prop_color_texture", colorTexturePropertyName, false);

  document
    .querySelectorAll('[data-color-texture-card][data-grouped-color-texture="true"]')
    .forEach((card) => {
      if (!isElementVisible(card)) return;

      const index = Array.prototype.indexOf.call(document.querySelectorAll('[data-color-texture-card][data-grouped-color-texture="true"]'), card);
      const colorLabel = cleanText(card.getAttribute("data-color-property-label"));
      const textureLabel = cleanText(card.getAttribute("data-texture-property-label"));
      const colorValue = getSelectedColorForScope(card);
      const textureData = getSelectedTextureDataForScope(card);
      const textureValue = cleanText(textureData && textureData.value ? textureData.value : "");
      const textureGroup = cleanText(textureData && textureData.group ? textureData.group : "");
      const isWoodCard = isWoodPropertyLabel(colorLabel);

      if (colorLabel) {
        const colorId = `grouped_prop_${toHiddenPropertyId(colorLabel)}_${index}`;
        if (isGenericGroupedColorTextureLabel(colorLabel) || isWoodCard) {
          setHiddenValue(colorId, `properties[${colorLabel}]`, "");
          setHiddenDisabled(colorId, `properties[${colorLabel}]`, true);
        } else {
          setHiddenValue(colorId, `properties[${colorLabel}]`, colorValue);
          setHiddenDisabled(colorId, `properties[${colorLabel}]`, !colorValue);
        }
      }

      if (textureLabel) {
        const textureId = `grouped_prop_${toHiddenPropertyId(textureLabel)}_${index}`;
        if (isGenericGroupedColorTextureLabel(textureLabel)) {
          setHiddenValue(textureId, `properties[${textureLabel}]`, "");
          setHiddenDisabled(textureId, `properties[${textureLabel}]`, true);
        } else {
          setHiddenValue(textureId, `properties[${textureLabel}]`, textureValue);
          setHiddenDisabled(textureId, `properties[${textureLabel}]`, !textureValue);
        }
      }

      if (colorLabel.toLowerCase() === "select powder coat") {
        setHiddenValue("prop_powder_coat", powderCoatPropertyName, colorValue);
        setHiddenValue("prop_select_powder_coat", powderCoatPropertyName, colorValue);
      }

      if (isWoodCard) {
        setHiddenValue("prop_select_wood", woodPropertyName, colorValue);
        setHiddenDisabled("prop_select_wood", woodPropertyName, !colorValue);
      }

      if (textureValue && textureValue !== "Decide Later") {
        if (textureGroup === "gfrc") {
          setHiddenValue("prop_gfrc_texture", gfrcTexturePropertyName, textureValue);
        } else if (textureGroup === "frp") {
          setHiddenValue("prop_frp_texture", frpTexturePropertyName, textureValue);
        } else if (textureGroup === "pre-weathering") {
          setHiddenValue("prop_finish", finishPropertyName, textureValue);
        }
      }

      const combinedSummary =
        colorValue && textureValue && textureValue !== "Decide Later"
          ? buildColorTextureSummary(colorValue, textureValue)
        /*
        : colorValue && textureValue === "Decide Later"
            ? cleanText(colorValue + ", TBD Texture")
        */
        : colorValue && textureValue === "Decide Later"
            ? "Decide Later"
            : colorValue
              ? colorValue
              /*
              : textureValue === "Decide Later"
                ? "TBD Texture"
              */
              : textureValue === "Decide Later"
                ? "Decide Later"
                : textureValue;

      if (!isWoodCard && textureGroup !== "powder-coat" && combinedSummary) {
        setHiddenValue("prop_color_texture", colorTexturePropertyName, combinedSummary);
        setHiddenDisabled("prop_color_texture", colorTexturePropertyName, false);
      }
    });

  setHiddenDisabled("prop_color", colorPropertyName, true);
  setHiddenDisabled("prop_gfrc_texture", gfrcTexturePropertyName, true);
  setHiddenDisabled("prop_frp_texture", frpTexturePropertyName, true);
  setHiddenDisabled("prop_finish", finishPropertyName, !getPropertyValueByName(finishPropertyName));
  setHiddenDisabled("prop_powder_coat", powderCoatPropertyName, !getPropertyValueByName(powderCoatPropertyName));
  setHiddenDisabled("prop_select_powder_coat", powderCoatPropertyName, true);
}

function getSelectedMaterial(scope) {
  return (
    getCheckedValueByOptionKey("select_product_material", scope) ||
    getCheckedValueByScope(scope || getQuoteScope(), '[name="properties[Select Product Material]"]')
  );
}

function getSelectedShape(scope) {
  return (
    getCheckedValueByOptionKey("select_shape", scope) ||
    getCheckedValueByScope(scope || getQuoteScope(), '[name="properties[Select Shape]"]')
  );
}

function getSelectedAddonValue(optionKey, fallbackName, scope) {
  const optionKeys = Array.isArray(optionKey) ? optionKey : [optionKey];
  const fallbackNames = Array.isArray(fallbackName) ? fallbackName : [fallbackName];
  const root = scope && typeof scope.querySelector === "function" ? scope : getQuoteScope();
  let value = "";
  let matchedKey = "";

  optionKeys.some((key) => {
    value = getCheckedValueByOptionKey(key, root);
    if (value) matchedKey = key;
    return !!value;
  });

  if (!value) {
    fallbackNames.some((name) => {
      if (!name) return false;
      value = getPropertyValueByName("properties[" + name + "]", root);
      return !!value;
    });
  }

  if (value && matchedKey) {
    const displayName = getCustomOptionTitle(matchedKey, fallbackNames[0], root);
    const normalizedValue = normalizeOptionTitleKey(value);
    const normalizedKey = normalizeOptionTitleKey(matchedKey);
    const normalizedDisplayName = normalizeOptionTitleKey(displayName);

    if (
      normalizedValue === normalizedKey ||
      normalizedValue === `select_${normalizedKey}`
    ) {
      value = "";
    } else if (
      (normalizedKey && normalizedValue.indexOf(normalizedKey) !== -1) ||
      (normalizedDisplayName && normalizedValue === normalizedDisplayName)
    ) {
      value = displayName;
    }
  }

  return value;
}

function isUsableLinkedProductInput(input) {
  if (!input || input.disabled) return false;
  if (input.closest("[data-aggregate-preview-root], [data-initial-aggregate-normal-options], [data-initial-aggregate-custom-modifications], [data-initial-aggregate-color-preview]")) return false;

  const hiddenBlock = input.closest("[hidden], [aria-hidden='true']");
  if (hiddenBlock) return false;

  const liveBlock = input.closest("[data-live-normal-metafield-options], [data-live-custom-modification-options], [data-live-variant-color-options]");
  if (liveBlock && (liveBlock.hidden || liveBlock.style.display === "none")) return false;

  const item = input.closest(".block-addon-option__item, .color-dependent-option, .block-color-texture-card__color-item, .block-color-texture-card__texture-item");
  if (item && (item.hidden || item.style.display === "none" || item.classList.contains("hidden"))) return false;

  return true;
}

function parseLinkedJson(value) {
  try {
    return JSON.parse(value || "[]");
  } catch (error) {
    return [];
  }
}

function getSelectedLinkedProductTitle(optionKeys, scope) {
  const keys = Array.isArray(optionKeys) ? optionKeys : [optionKeys];
  const root = scope && typeof scope.querySelectorAll === "function" ? scope : getQuoteScope();
  const inputs = Array.from(root.querySelectorAll(".custom-option-radio[data-linked-variant-id]"));
  const matchesOption = (candidate) => {
    const key = String(candidate.getAttribute("data-option-key") || "").toLowerCase();
    const name = String(candidate.getAttribute("data-option-name") || "").toLowerCase();
    return keys.some((optionKey) => {
      const normalizedKey = String(optionKey).toLowerCase();
      return key === normalizedKey ||
        key.indexOf(normalizedKey) !== -1 ||
        name.indexOf(normalizedKey) !== -1 ||
        (normalizedKey.indexOf("irrig") !== -1 && (key.indexOf("irrig") !== -1 || name.indexOf("irrig") !== -1));
    });
  };
  const input = inputs.find((candidate) => candidate.checked && matchesOption(candidate) && isUsableLinkedProductInput(candidate)) ||
    inputs.find((candidate) => candidate.checked && matchesOption(candidate));

  return getLinkedProductDisplayTitle(input);
}

function getLinkedProductDisplayTitle(input) {
  if (!input) return "";

  const productTitle = cleanText(input.getAttribute("data-linked-product-title"));
  const variantOptions = parseLinkedJson(input.getAttribute("data-linked-variant-options"));
  const variantTitle = Array.isArray(variantOptions)
    ? variantOptions.map((option) => cleanText(option)).filter((option) => option && option.toLowerCase() !== "default title").join(" / ")
    : "";

  if (productTitle && variantTitle && productTitle.toLowerCase() !== variantTitle.toLowerCase()) {
    return `${productTitle} - ${variantTitle}`;
  }

  return productTitle || variantTitle;
}

function getSelectedAddonPriceTotal() {
  const priceEl = document.querySelector("#final_price, .final-price");
  const basePrice = Number(
    String(
      (priceEl && (priceEl.getAttribute("data-variant-price") || priceEl.getAttribute("data-base"))) ||
      ""
    ).replace(/[^0-9.-]/g, "")
  );
  let total = Number.isFinite(basePrice) && basePrice > 0 ? basePrice : 0;

  const isIrrigationInput = (input) => {
    const optionKey = String(input.getAttribute("data-option-key") || "").toLowerCase();
    const optionName = String(input.getAttribute("data-option-name") || "").toLowerCase();
    const propertyName = String(input.getAttribute("name") || "").toLowerCase();

    return optionKey.includes("irrig") || optionName.includes("irrig") || propertyName.includes("irrig");
  };
  const isWillardKitInput = (input) => {
    const optionKey = String(input.getAttribute("data-option-key") || "").toLowerCase();
    const optionName = String(input.getAttribute("data-option-name") || "").toLowerCase();
    const propertyName = String(input.getAttribute("name") || "").toLowerCase();

    return optionKey.includes("willard") || optionName.includes("willard") || propertyName.includes("willard");
  };

  const selectedInputs = document.querySelectorAll(
    ".custom-option-radio:checked, .block-standard-option input:checked, .block-color-texture-card input:checked, input[data-price]:checked, input[data-display-price]:checked"
  );

  selectedInputs.forEach((input) => {
    if (!input || input.disabled) return;
    if (isIrrigationInput(input) || isWillardKitInput(input)) return;

    const prices = [
      input.getAttribute("data-display-price"),
      input.getAttribute("data-price")
    ]
      .map((rawPrice) => Number(String(rawPrice || "").replace(/[^0-9.-]/g, "")))
      .filter((price) => Number.isFinite(price) && price > 0);

    const linkedProductPrice = Number(input.getAttribute("data-linked-product-price") || 0);
    if (Number.isFinite(linkedProductPrice) && linkedProductPrice > 0) {
      prices.push(linkedProductPrice / 100);
    }

    if (prices.length) {
      total += Math.max(...prices);
    }
  });

  return total > 0 ? total.toFixed(2) : "";
}

function getPropertyValueByName(name, scope) {
  const selectorName = String(name || "").replace(/"/g, '\\"');
  const root = scope && typeof scope.querySelectorAll === "function" ? scope : getQuoteScope();
  const fields = root.querySelectorAll(
    'input[name="' + selectorName + '"], select[name="' + selectorName + '"], textarea[name="' + selectorName + '"]'
  );

  for (const field of fields) {
    if (field.disabled) continue;

    if ((field.type === "radio" || field.type === "checkbox") && !field.checked) {
      continue;
    }

    const value = getFieldPropertyValue(field);

    if (value) return value;
  }

  return "";
}

function updateQuoteHiddenColorTextureSummary() {
  if (hasGroupedColorTextureCards()) {
    updateGroupedColorTextureProperties();
    return;
  }

  const colorPropertyName = getCustomOptionPropertyName("select_color", "Select Color");
  const gfrcTexturePropertyName = getCustomOptionPropertyName("choose_1_of_5_gfrc_textures", "GFRC Texture");
  const frpTexturePropertyName = getCustomOptionPropertyName("choose_1_of_3_frp_textures", "FRP Texture");
  const finishPropertyName = getCustomOptionPropertyName("pre_weathering_finish", "Pre Weathering Finish");
  const powderCoatPropertyName = getCustomOptionPropertyName("powder_coat", "Powder-Coat");
  const colorTexturePropertyName = getCustomOptionPropertyName("color_texture", "Color & Texture");

  setHiddenDisabled("prop_color", colorPropertyName, false);
  setHiddenDisabled("prop_gfrc_texture", gfrcTexturePropertyName, false);
  setHiddenDisabled("prop_frp_texture", frpTexturePropertyName, false);
  setHiddenDisabled("prop_finish", finishPropertyName, false);
  setHiddenDisabled("prop_powder_coat", powderCoatPropertyName, false);

  const colorValue = getSelectedColor();
  const textureData = getSelectedTextureData();
  const textureValue = textureData.value;
  const textureGroup = textureData.group;

  setHiddenValue("prop_color", colorPropertyName, colorValue);

  setHiddenValue("prop_gfrc_texture", gfrcTexturePropertyName, "");
  setHiddenValue("prop_frp_texture", frpTexturePropertyName, "");
  setHiddenValue("prop_finish", finishPropertyName, "");
  setHiddenValue("prop_powder_coat", powderCoatPropertyName, "");

  if (textureValue && textureValue !== "Decide Later") {
    if (textureGroup === "gfrc") {
      setHiddenValue("prop_gfrc_texture", gfrcTexturePropertyName, textureValue);
    } else if (textureGroup === "frp") {
      setHiddenValue("prop_frp_texture", frpTexturePropertyName, textureValue);
    } else if (textureGroup === "pre-weathering") {
      setHiddenValue("prop_finish", finishPropertyName, textureValue);
    } else if (textureGroup === "powder-coat") {
      setHiddenValue("prop_powder_coat", powderCoatPropertyName, textureValue);
    } else {
      setHiddenValue("prop_gfrc_texture", gfrcTexturePropertyName, textureValue);
    }
  }

  const combinedSummary =
    colorValue && textureValue && textureValue !== "Decide Later"
      ? buildColorTextureSummary(colorValue, textureValue)
    /*
    : colorValue && textureValue === "Decide Later"
      ? cleanText(colorValue + ", TBD Texture")
    */
    : colorValue && textureValue === "Decide Later"
      ? "Decide Later"
    : colorValue
      ? colorValue
          : textureValue;

  if (textureGroup === "powder-coat") {
    setHiddenValue("prop_color_texture", colorTexturePropertyName, "");
    setHiddenDisabled("prop_color_texture", colorTexturePropertyName, true);
  } else {
    setHiddenValue("prop_color_texture", colorTexturePropertyName, combinedSummary);
    setHiddenDisabled("prop_color_texture", colorTexturePropertyName, !combinedSummary);
  }

  setHiddenDisabled("prop_color", colorPropertyName, true);
  setHiddenDisabled("prop_gfrc_texture", gfrcTexturePropertyName, true);
  setHiddenDisabled("prop_frp_texture", frpTexturePropertyName, true);
  setHiddenDisabled("prop_finish", finishPropertyName, !getPropertyValueByName(finishPropertyName));
  setHiddenDisabled("prop_powder_coat", powderCoatPropertyName, !getPropertyValueByName(powderCoatPropertyName));
  setHiddenDisabled("prop_select_powder_coat", powderCoatPropertyName, true);
}

function updateQuoteDimensionHiddenProperties() {
  const form = getForm();
  const scopedRoot =
    (form && form.closest && form.closest(".product-info")) ||
    document.querySelector(".product-info") ||
    document;

  const seenKeys = new Set();

  scopedRoot.querySelectorAll("[data-custom-dimensions-picker] [data-dimension-option]").forEach((group) => {
    const rawName =
      group.getAttribute("data-option-name") ||
      group.getAttribute("data-dimension-option") ||
      "";
    const optionName = cleanText(rawName);

    if (!optionName) return;

    const selectedInput = group.querySelector('input[type="radio"]:checked');
    const optionValue = cleanText(
      (selectedInput && (
        selectedInput.getAttribute("data-option-value") ||
        selectedInput.getAttribute("data-value") ||
        selectedInput.value
      )) || ""
    );

    const hiddenId = "prop_dimension_" + toHiddenPropertyId(optionName);
    const hiddenName = "properties[" + optionName + "]";

    seenKeys.add(hiddenId);

    if (optionValue && optionValue.toLowerCase().indexOf("custom") === -1) {
      setHiddenValue(hiddenId, hiddenName, optionValue);
      setHiddenDisabled(hiddenId, hiddenName, false);
      return;
    }

    setHiddenValue(hiddenId, hiddenName, "");
    setHiddenDisabled(hiddenId, hiddenName, true);
  });

  scopedRoot.querySelectorAll("[data-custom-dimensions-picker] [data-store-only-property='true']").forEach((field) => {
    const optionName =
      cleanText(
        getPropertyKeyFromField(field) ||
        field.getAttribute("data-custom-dimension-field") ||
        ""
      );

    if (!optionName) return;

    const hiddenId = "prop_dimension_" + toHiddenPropertyId(optionName);
    const hiddenName = "properties[" + optionName + "]";
    const optionValue = cleanText(field.value);
    const picker = field.closest("[data-custom-dimensions-picker]");
    const customMode = !!(picker && (
      picker.classList.contains("custom-dimensions-picker--custom-mode") ||
      picker.classList.contains("custom-dimensions-picker--customize-active")
    ));

    seenKeys.add(hiddenId);

    if (optionValue && (customMode || !field.disabled)) {
      setHiddenValue(hiddenId, hiddenName, optionValue);
      setHiddenDisabled(hiddenId, hiddenName, false);
      return;
    }

    const existingInput = getHiddenInput(hiddenId, hiddenName);
    if (existingInput && !existingInput.value) {
      existingInput.disabled = true;
    }
  });
}

function getSelectedDimensionPickerProperties(scopedRoot) {
  const properties = {};
  const root = scopedRoot && typeof scopedRoot.querySelectorAll === "function" ? scopedRoot : document;

  root.querySelectorAll("[data-custom-dimensions-picker] [data-dimension-option]").forEach((group) => {
    const rawName =
      group.getAttribute("data-option-name") ||
      group.getAttribute("data-dimension-option") ||
      "";
    const optionName = cleanText(rawName);

    if (!optionName) return;

    const selectedInput = group.querySelector('input[type="radio"]:checked:not(:disabled)');
    const optionValue = cleanText(
      (selectedInput && (
        selectedInput.getAttribute("data-option-value") ||
        selectedInput.getAttribute("data-value") ||
        selectedInput.value
      )) || ""
    );

    if (optionValue && optionValue.toLowerCase().indexOf("custom") === -1) {
      addQuoteProperty(properties, optionName, optionValue);
    }
  });

  root.querySelectorAll("[data-custom-dimensions-picker] [data-store-only-property='true']").forEach((field) => {
    const picker = field.closest("[data-custom-dimensions-picker]");
    const customMode = !!(picker && (
      picker.classList.contains("custom-dimensions-picker--custom-mode") ||
      picker.classList.contains("custom-dimensions-picker--customize-active")
    ));
    if (field.disabled && !customMode) return;

    const optionName = cleanText(
      getPropertyKeyFromField(field) ||
      field.getAttribute("data-custom-dimension-field") ||
      ""
    );
    const optionValue = cleanText(field.value);

    addQuoteProperty(properties, optionName, optionValue);
  });

  return properties;
}

function getSelectedQuoteOnlyProperties(scopedRoot) {
  const properties = {};
  const root = scopedRoot && typeof scopedRoot.querySelectorAll === "function" ? scopedRoot : document;

  root.querySelectorAll(
    '[data-option-group="quote-only"] input[type="checkbox"]:checked:not(:disabled), ' +
      '[data-option-group="quote-only"] input[type="radio"]:checked:not(:disabled), ' +
      'input[data-quote-only="true"]:checked:not(:disabled)'
  ).forEach((input) => {
    const group = input.closest('[data-option-group="quote-only"], .block-addon-option, .option-wrapper-field, .product-form__input');
    const optionKey = cleanText(
      input.getAttribute("data-option-key") ||
        (group && group.getAttribute("data-option-key")) ||
        ""
    );
    const optionName = cleanText(
      input.getAttribute("data-option-name") ||
        (group && group.getAttribute("data-option-name")) ||
        getPropertyKeyFromField(input)
    );
    const optionLabel = cleanText(
      input.getAttribute("data-option-label") ||
        (input.id && group && group.querySelector(`label[for="${quoteCssEscape(input.id)}"]`)
          ? group.querySelector(`label[for="${quoteCssEscape(input.id)}"]`).textContent
          : "") ||
        optionName
    );
    const rawValue = cleanText(
      input.getAttribute("data-option-value") ||
        input.getAttribute("data-value") ||
        input.value ||
        optionLabel
    );
    const key = optionKey
      ? getCustomOptionTitle(optionKey, optionName || optionLabel || optionKey, root)
      : optionName || optionLabel;
    const value = rawValue || optionLabel || optionName;

    addQuotePropertyValue(properties, key, value);
  });

  return properties;
}

function updateAllQuoteHiddenProperties() {
  const scope = getQuoteScope();
  const propertyName = (key, fallback) => getCustomOptionPropertyName(key, fallback || key, scope);
  const optionTitle = (key, fallback) => getCustomOptionTitle(key, fallback || key, scope);

  setHiddenValue("prop_material", propertyName("select_product_material", "Material"), getSelectedMaterial(scope));
  setHiddenValue("prop_shape", propertyName("select_shape", "Select Shape"), getSelectedShape(scope));
  setHiddenValue("prop_custom_option_title_map", "properties[_custom_option_title_map]", getCustomOptionTitleMap(scope));
  updateQuoteDimensionHiddenProperties();

  updateQuoteHiddenColorTextureSummary();
  setHiddenValue("prop_custom_color", propertyName("custom_color", "Custom Color"), getSelectedAddonValue(["custom_color", "custom_colour"], [optionTitle("custom_color", "Custom Color"), "Custom Colour"], scope));

  setHiddenValue("prop_drainage", propertyName("drainage_holes", "Drainage Holes"), getSelectedAddonValue("drainage_holes", optionTitle("drainage_holes", "Drainage Holes"), scope));
  setHiddenValue("prop_toe_kick", propertyName("toe_kick", "Toe Kick"), getSelectedAddonValue("toe_kick", optionTitle("toe_kick", "Toe Kick"), scope));
  const irrigationValue = getSelectedAddonValue(["irrigation_insert", "irrigation"], [optionTitle("irrigation", "Irrigation System"), "Irrigation"], scope);
  const irrigationProductTitle = getSelectedLinkedProductTitle(["irrigation_insert", "irrigation"], scope);
  // Keep the selected product name in the parent quote line. Irrigation is an
  // option of the planter, not a second quote-basket product.
  setHiddenValue("prop_irrigation_insert", "properties[Irrigation]", irrigationProductTitle || irrigationValue);

  setHiddenValue("prop_cut_length", propertyName("cut_length_shorter", "Cut Length Shorter"), getSelectedAddonValue("cut_length_shorter", optionTitle("cut_length_shorter", "Cut Length Shorter"), scope));
  setHiddenValue("prop_cut_width", propertyName("cut_width_shorter", "Cut Width Shorter"), getSelectedAddonValue("cut_width_shorter", optionTitle("cut_width_shorter", "Cut Width Shorter"), scope));
  setHiddenValue("prop_cut_height", propertyName("cut_height_shorter", "Cut Height Shorter"), getSelectedAddonValue("cut_height_shorter", optionTitle("cut_height_shorter", "Cut Height Shorter"), scope));
  setHiddenValue("prop_scoops", propertyName("scoops", "Scoops"), getSelectedAddonValue("scoops", optionTitle("scoops", "Scoops"), scope));
  setHiddenValue("prop_casters", propertyName("casters", "Casters"), getSelectedAddonValue("casters", optionTitle("casters", "Casters"), scope));
  setHiddenValue("prop_false_bottom", propertyName("false_bottom", "False Bottom"), getSelectedAddonValue("false_bottom", optionTitle("false_bottom", "False Bottom"), scope));
  setHiddenValue("prop_bottom_reinforcement", propertyName("bottom_reinforcement", "Bottom Reinforcement"), getSelectedAddonValue("bottom_reinforcement", optionTitle("bottom_reinforcement", "Bottom Reinforcement"), scope));
  setHiddenValue("prop_tie_downs", propertyName("tie_downs", "Tie Downs"), getSelectedAddonValue("tie_downs", optionTitle("tie_downs", "Tie Downs"), scope));
  setHiddenValue("prop_tourneseal", propertyName("tourneseal", "tourneseal"), getSelectedAddonValue("tourneseal", optionTitle("tourneseal", "tourneseal"), scope));
  setHiddenValue("prop_anchor_plate", propertyName("anchor_plate", "Anchor Plate"), getSelectedAddonValue("anchor_plate", optionTitle("anchor_plate", "Anchor Plate"), scope));
  const willardAnchoringKitValue = getSelectedAddonValue("willard_anchoring_kit", optionTitle("willard_anchoring_kit", "Willard Bench Anchoring Kit"), scope);
  const willardAnchoringKitTitle = getSelectedLinkedProductTitle(["willard_anchoring_kit"], scope);
  setHiddenValue("prop_willard_anchoring_kit", propertyName("willard_anchoring_kit", "Willard Bench Anchoring Kit"), willardAnchoringKitTitle || willardAnchoringKitValue);

  const willardJoiningKitValue = getSelectedAddonValue("willard_joining_kit", optionTitle("willard_joining_kit", "Willard Bench Joining Kit"), scope);
  const willardJoiningKitTitle = getSelectedLinkedProductTitle(["willard_joining_kit"], scope);
  setHiddenValue("prop_willard_joining_kit", propertyName("willard_joining_kit", "Willard Bench Joining Kit"), willardJoiningKitTitle || willardJoiningKitValue);
}

let hiddenPropertiesFrame = null;
let hiddenPropertiesTimer = null;

function scheduleHiddenPropertiesUpdate() {
  if (hiddenPropertiesFrame === null) {
    hiddenPropertiesFrame = requestAnimationFrame(function () {
      hiddenPropertiesFrame = null;
      updateAllQuoteHiddenProperties();
    });
  }

  clearTimeout(hiddenPropertiesTimer);
  hiddenPropertiesTimer = setTimeout(function () {
    hiddenPropertiesTimer = null;
    updateAllQuoteHiddenProperties();
  }, 180);
}

window.updateAllQuoteHiddenProperties = updateAllQuoteHiddenProperties;
window.getCurrentLineItemProperties = getCurrentLineItemProperties;
window.syncCurrentLineItemPropertiesToForm = syncCurrentLineItemPropertiesToForm;
window.getSelectedQuoteImage = getSelectedQuoteImage;

/* =========================
   CARET SVG
========================= */
function getCaretSvg(isOpen = false) {
  return `
    <svg class="icon icon-caret quote-arrow${isOpen ? " is-open" : ""}" viewBox="0 0 10 6" aria-hidden="true" focusable="false">
      <path d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"></path>
    </svg>
  `;
}

/* =========================
   TOGGLE BUTTON HTML
========================= */
function getToggleButtonHtml(index, isOpen = false) {
  return `
    <button type="button" class="quote-more-toggle" data-index="${index}">
      ${isOpen ? "Show less" : "Show more"}
      ${getCaretSvg(isOpen)}
    </button>
  `;
}

/* =========================
   GET VARIANT
========================= */
function getCurrentVariant(triggerButton) {
  const scopedRoot =
    (triggerButton && triggerButton.closest && triggerButton.closest(".product-info")) ||
    (triggerButton && triggerButton.closest && triggerButton.closest("[id^='x-product-template-'], .shopify-section, .product-section")) ||
    document.querySelector(".product-info") ||
    document;

  const form =
    (triggerButton && triggerButton.closest && triggerButton.closest("form")) ||
    scopedRoot.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]') ||
    document.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');

  const picker =
    scopedRoot.querySelector('[data-custom-dimensions-picker]:not(.custom-dimensions-picker--cwm-model)') ||
    document.querySelector('[data-custom-dimensions-picker]:not(.custom-dimensions-picker--cwm-model)');

  const isCustomMode = !!(picker && (
    picker.classList.contains("custom-dimensions-picker--custom-mode") ||
    picker.classList.contains("custom-dimensions-picker--customize-active") ||
    (window.CustomDimensionsModeState && window.CustomDimensionsModeState[picker.getAttribute("data-dimensions-dedupe-key") || ""] === "custom") ||
    Array.from(picker.querySelectorAll("[data-store-only-property='true']")).some((f) => cleanText(f.value))
  ));

  const syncedVariantId = picker ? picker.getAttribute("data-synced-variant-id") : null;
  const formVariantInput = form ? form.querySelector('input[name="id"], select[name="id"]') : null;
  const scopedVariantInput =
    scopedRoot.querySelector('input[name="id"][value], select[name="id"]') ||
    scopedRoot.querySelector('[id^="update-variant-"][value]') ||
    document.querySelector('input[name="id"][value]') ||
    document.querySelector('[id^="update-variant-"][value]');
  const urlVariantId = (new URL(window.location.href)).searchParams.get("variant");

  const activeVariantId = cleanText(
    syncedVariantId ||
    (formVariantInput && formVariantInput.value) ||
    (scopedVariantInput && scopedVariantInput.value) ||
    urlVariantId ||
    ""
  );

  let dimensionVariants = [];
  const dimVariantsEl =
    scopedRoot.querySelector("[data-dimension-variants]") ||
    document.querySelector("[data-dimension-variants]");
  if (dimVariantsEl) {
    try {
      dimensionVariants = JSON.parse(dimVariantsEl.textContent) || [];
    } catch (e) {}
  }

  let variantMetaFields = {};
  const metaScript =
    scopedRoot.querySelector('[id^="VariantMetaFields-"]') ||
    document.querySelector('[id^="VariantMetaFields-"]');
  if (metaScript) {
    try {
      variantMetaFields = JSON.parse(metaScript.textContent) || {};
    } catch (e) {}
  }

  const el =
    scopedRoot.querySelector("[data-selected-variant]") ||
    document.querySelector("[data-selected-variant]");

  let scriptVariant = null;
  if (el) {
    try {
      scriptVariant = JSON.parse(el.textContent);
    } catch (e) {
      console.warn("Variant parse error", e);
    }
  }

  const productTitle =
    cleanText(
      scopedRoot.querySelector(".product__title, .product-title, h1")?.textContent ||
      document.querySelector(".product__title, .product-title, h1")?.textContent
    ) || "";

  if (isCustomMode) {
    let customVariant = dimensionVariants.find((v) => {
      if (activeVariantId && String(v.id) === String(activeVariantId)) return true;
      const opts = `${v.option1 || ""} ${v.option2 || ""} ${v.option3 || ""} ${v.title || ""}`.toLowerCase();
      return opts.includes("custom");
    });

    const targetId = (customVariant && customVariant.id) || activeVariantId || (scriptVariant && scriptVariant.id);
    const meta = targetId ? variantMetaFields[String(targetId)] : null;

    if (targetId) {
      return {
        id: Number(targetId) || targetId,
        title: meta?.title || (customVariant && customVariant.title) || "Custom",
        options: meta?.options || (customVariant ? [customVariant.option1, customVariant.option2, customVariant.option3].filter(Boolean) : []),
        price: meta?.price ? Math.round(meta.price * 100) : (scriptVariant?.price || ""),
        sku: cleanText(customVariant?.sku || scriptVariant?.sku || ""),
        product_title: productTitle,
        name: productTitle
      };
    }
  }

  if (activeVariantId) {
    if (scriptVariant && String(scriptVariant.id) === String(activeVariantId)) {
      return scriptVariant;
    }
    const matchedDimVariant = dimensionVariants.find((v) => String(v.id) === String(activeVariantId));
    const meta = variantMetaFields[String(activeVariantId)];
    if (matchedDimVariant || meta) {
      return {
        id: Number(activeVariantId) || activeVariantId,
        title: meta?.title || matchedDimVariant?.title || scriptVariant?.title || "",
        options: meta?.options || (matchedDimVariant ? [matchedDimVariant.option1, matchedDimVariant.option2, matchedDimVariant.option3].filter(Boolean) : (scriptVariant?.options || [])),
        price: meta?.price ? Math.round(meta.price * 100) : (scriptVariant?.price || ""),
        sku: cleanText(matchedDimVariant?.sku || scriptVariant?.sku || ""),
        product_title: productTitle,
        name: productTitle
      };
    }
  }

  if (scriptVariant && scriptVariant.id) {
    return scriptVariant;
  }

  if (activeVariantId) {
    return {
      id: Number(activeVariantId) || activeVariantId,
      price: "",
      options: [],
      product_title: productTitle,
      name: productTitle
    };
  }

  return null;
}

/* =========================
   GET OPTIONS FROM VARIANT
========================= */
function getVariantOptions(variant) {
  let options = {};

  if (!variant || !variant.options) return options;

  const optionEls = document.querySelectorAll("[data-option-index][data-option-name]");
  const optionNames = [];

  optionEls.forEach((el) => {
    const idx = parseInt(el.getAttribute("data-option-index"), 10);
    const name = el.getAttribute("data-option-name");

    if (!isNaN(idx) && name) {
      const legend = el.querySelector(
        "legend, label, .form__label, .block-standard-option__legend, .product-form__input-label"
      );

      const legendText = legend ? String(legend.textContent || legend.innerText || "") : "";
      const rawName = legend
        ? cleanText(legendText.replace(/:.*/g, ""))
        : cleanText(
            name
              .split("-")
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
              .join(" ")
          );

      optionNames[idx] = rawName || name;
    }
  });

  variant.options.forEach((val, i) => {
    if (!val || val === "Default Title") return;

    const label = optionNames[i] || "Option " + (i + 1);
    options[label] = val;
  });

  return options;
}

/* =========================
   FIELD VALUE HELPER
========================= */
function getFieldPropertyValue(field) {
  if (!field) return "";

  const tagName = field.tagName ? field.tagName.toLowerCase() : "";
  const type = field.type ? field.type.toLowerCase() : "";

  if ((type === "checkbox" || type === "radio") && !field.checked) {
    return "";
  }

  if (tagName === "select") {
    const selectedOption = field.options[field.selectedIndex];

    return cleanText(
      field.value ||
        field.getAttribute("data-selected-value") ||
        (selectedOption ? selectedOption.textContent : "")
    );
  }

  if (type === "file") {
    return field.files && field.files.length
      ? Array.from(field.files).map((file) => file.name).join(", ")
      : "";
  }

  return cleanText(field.value || field.getAttribute("data-selected-value") || "");
}

/* =========================
   GET LABEL FROM FIELD
========================= */
function getPropertyKeyFromField(field) {
  const name = field.getAttribute("name") || "";
  const match = name.match(/^properties\[(.*)\]$/);

  if (match && match[1]) {
    return cleanText(match[1]);
  }

  return cleanText(
    field.getAttribute("data-quote-property-name") ||
      field.getAttribute("data-property-name") ||
      field.getAttribute("data-property-key") ||
      field.getAttribute("aria-label") ||
      ""
  );
}

/* =========================
   GET CUSTOM GROUP KEY
========================= */
function getCustomGroupKey(group) {
  if (!group) return "";

  const attrKey =
    group.getAttribute("data-quote-property-name") ||
    group.getAttribute("data-property-name") ||
    group.getAttribute("data-property-key") ||
    group.getAttribute("data-option-name");

  if (attrKey) {
    return cleanText(
      attrKey
        .split("-")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ")
    );
  }

  const labelEl = group.querySelector(
    "legend, .form__label, .block-standard-option__legend, .product-form__input-label, .option-label, .option-title"
  );

  if (labelEl) {
    const labelText = String(labelEl.textContent || labelEl.innerText || "");
    return cleanText(labelText.replace(/:.*/g, ""));
  }

  return "";
}

/* =========================
   GET SELECTED CUSTOM VALUE
========================= */
function getCustomGroupValue(group) {
  if (!group) return "";

  const directSelectedValue =
    group.getAttribute("data-selected-value") ||
    group.getAttribute("data-current-value");

  if (directSelectedValue) {
    return cleanText(directSelectedValue);
  }

  const selectedInput = group.querySelector(
    'input[type="radio"]:checked, input[type="checkbox"]:checked'
  );

  if (selectedInput) {
    let value = selectedInput.value;

    if (
      selectedInput.id &&
      group.querySelector(`label[for="${quoteCssEscape(selectedInput.id)}"]`)
    ) {
      const label = group.querySelector(`label[for="${quoteCssEscape(selectedInput.id)}"]`);
      value = label ? (label.textContent || label.innerText || selectedInput.value) : selectedInput.value;
    }

    return cleanText(
      selectedInput.getAttribute("data-value") ||
        selectedInput.getAttribute("data-option-value") ||
        value
    );
  }

  const selectedEl = group.querySelector(
    '[aria-pressed="true"], [aria-selected="true"], [data-selected="true"], .is-selected, .selected, .active, .current'
  );

  if (selectedEl) {
    return cleanText(
      selectedEl.getAttribute("data-value") ||
        selectedEl.getAttribute("data-option-value") ||
        selectedEl.getAttribute("data-selected-value") ||
        selectedEl.getAttribute("title") ||
        selectedEl.textContent ||
        selectedEl.innerText ||
        ""
    );
  }

  const select = group.querySelector("select");
  if (select) {
    return getFieldPropertyValue(select);
  }

  const hiddenWithValue = group.querySelector(
    'input[type="hidden"][name^="properties["][value]:not([value=""])'
  );

  if (hiddenWithValue) {
    return getFieldPropertyValue(hiddenWithValue);
  }

  return "";
}

/* =========================
   GET LINE ITEM PROPERTIES
========================= */
function getCurrentLineItemProperties() {
  if (typeof window.updateAllQuoteHiddenProperties === "function") {
    window.updateAllQuoteHiddenProperties();
  }

  const properties = {};
  const form = getForm();

  if (!form) return properties;

  const scopedRoot =
    (form.closest && form.closest(".product-info")) ||
    (form.parentElement && form.parentElement.closest && form.parentElement.closest(".product-info")) ||
    document;

  const formId = form.getAttribute("id");
  const fields = new Set();

  form
    .querySelectorAll(
      'input[name^="properties["], select[name^="properties["], textarea[name^="properties["]'
    )
    .forEach((field) => fields.add(field));

  if (formId) {
    const safeFormId = quoteCssEscape(formId);

    document
      .querySelectorAll(
        `input[form="${safeFormId}"][name^="properties["], select[form="${safeFormId}"][name^="properties["], textarea[form="${safeFormId}"][name^="properties["]`
      )
      .forEach((field) => fields.add(field));
  }

  fields.forEach((field) => {
    if (field.disabled) {
      const picker = field.closest && field.closest("[data-custom-dimensions-picker]");
      const customMode = !!(picker && (
        picker.classList.contains("custom-dimensions-picker--custom-mode") ||
        picker.classList.contains("custom-dimensions-picker--customize-active")
      ));
      if (!customMode || !field.matches("[data-store-only-property='true']") || !cleanText(field.value)) return;
    }

    // The visible checkbox for irrigation / Willard anchoring & joining kits
    // submits its own raw "Yes" value under this same property name. It's
    // processed after the dedicated hidden field (set above with the real
    // linked product title) and would otherwise clobber it, since
    // addQuoteProperty always overwrites. Skip it here; the hidden field
    // already covers this key.
    if (
      field.id !== "prop_irrigation_insert" &&
      field.id !== "prop_willard_anchoring_kit" &&
      field.id !== "prop_willard_joining_kit" &&
      field.classList.contains("custom-option-radio")
    ) {
      const fieldOptionKey = String(field.getAttribute("data-option-key") || "").toLowerCase();
      if (fieldOptionKey.indexOf("irrig") !== -1 || fieldOptionKey.indexOf("willard") !== -1) return;
    }

    const key = getPropertyKeyFromField(field);
    const value = getFieldPropertyValue(field);

    addQuoteProperty(properties, key, value);
  });

  const customGroups = scopedRoot.querySelectorAll(
    [
      "[data-quote-property-name]",
      "[data-property-name]",
      "[data-property-key]",
      ".custom-option",
      ".custom-product-option",
      ".block-standard-option",
      ".product-form__input",
      ".product-option"
    ].join(",")
  );

  customGroups.forEach((group) => {
    // Irrigation and the Willard anchoring/joining kits are already captured
    // above (via their dedicated hidden fields, which resolve the real
    // linked product title). This generic fieldset pass only sees the raw
    // checkbox value ("Yes") and would blindly overwrite that richer value,
    // so skip it here.
    const groupOptionKey = String(group.getAttribute("data-option-key") || "").toLowerCase();
    if (groupOptionKey.indexOf("irrig") !== -1 || groupOptionKey.indexOf("willard") !== -1) return;

    const key = getCustomGroupKey(group);
    const value = getCustomGroupValue(group);

    if (!key || !value) return;

    addQuoteProperty(properties, key, value);
  });

  const liveColorTextureProperties = buildCurrentColorTextureProperties(scopedRoot);

  Object.entries(liveColorTextureProperties || {}).forEach(([key, value]) => {
    addQuoteProperty(properties, key, value);
  });

  const selectedDimensionProperties = getSelectedDimensionPickerProperties(scopedRoot);

  Object.entries(selectedDimensionProperties || {}).forEach(([key, value]) => {
    addQuoteProperty(properties, key, value);
  });

  const selectedQuoteOnlyProperties = getSelectedQuoteOnlyProperties(scopedRoot);

  scopedRoot.querySelectorAll(
    '[data-option-group="quote-only"] input[type="checkbox"]:checked:not(:disabled), ' +
      '[data-option-group="quote-only"] input[type="radio"]:checked:not(:disabled), ' +
      'input[data-quote-only="true"]:checked:not(:disabled)'
  ).forEach((input) => {
    const group = input.closest('[data-option-group="quote-only"], .block-addon-option, .option-wrapper-field, .product-form__input');
    const optionKey = cleanText(
      input.getAttribute("data-option-key") ||
        (group && group.getAttribute("data-option-key")) ||
        ""
    );
    const rawKey = getPropertyKeyFromField(input);
    const mappedKey = optionKey
      ? getCustomOptionTitle(optionKey, rawKey || optionKey, scopedRoot)
      : "";

    if (rawKey && mappedKey && rawKey !== mappedKey) {
      delete properties[rawKey];
    }
  });

  Object.entries(selectedQuoteOnlyProperties || {}).forEach(([key, value]) => {
    addQuotePropertyValue(properties, key, value);
  });

  const irrigationLabel = getCustomOptionTitle("irrigation", "Irrigation System", scopedRoot);
  const irrigationProductTitle = getSelectedLinkedProductTitle(["irrigation_insert", "irrigation"], scopedRoot);
  const existingIrrigationValue = cleanText(
    properties[irrigationLabel] ||
    properties.Irrigation ||
    properties["Irrigation Insert"] ||
    properties["Irrigation System"] ||
    ""
  );
  // A selected irrigation toggle with no mapped product has no linked title, and
  // the generic passes above skip irrigation inputs, so send "Yes" for the estimator.
  const isIrrigationToggleSelected = Array.from(
    scopedRoot.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked')
  ).some((input) => {
    if (input.disabled) return false;
    const optionId = `${input.getAttribute("data-option-key") || ""} ${input.getAttribute("data-option-name") || ""}`.toLowerCase();
    const optionValue = cleanText(input.value).toLowerCase();
    return optionId.indexOf("irrig") !== -1 && ["no", "false", "off", "none"].indexOf(optionValue) === -1;
  });
  let normalizedIrrigationValue = irrigationProductTitle || existingIrrigationValue || (isIrrigationToggleSelected ? "Yes" : "");

  if (
    normalizedIrrigationValue &&
    normalizeOptionTitleKey(normalizedIrrigationValue) === normalizeOptionTitleKey(irrigationLabel)
  ) {
    normalizedIrrigationValue = "Yes";
  }

  if (normalizedIrrigationValue) {
    delete properties.Irrigation;
    delete properties["Irrigation Insert"];
    properties[irrigationLabel] = normalizedIrrigationValue;
  }

  return sortSubmittedLineItemProperties(
    sanitizeSubmittedLineItemProperties(
      mergeKnownHiddenPropertyFallbacks(properties)
    )
  );
}

function syncCurrentLineItemPropertiesToForm(form) {
  const targetForm = form || getForm();
  if (!targetForm) return {};

  const properties = getCurrentLineItemProperties();
  const target = targetForm.querySelector(".prop-info") || targetForm;
  const handledKeys = new Set();

  // These are internal helpers and must never be submitted with a line item.
  // The title map is only kept alongside a real custom option.
  ["_custom_option_order", "_quote_image", "__addonprice", "_color_swatch", "_wood_swatch", "_powder_coat_swatch"].forEach((key) => {
    delete properties[key];
  });

  const hasCustomSelection = Object.keys(properties).some((key) => {
    const cleanKey = cleanText(key);
    return cleanKey && cleanKey.charAt(0) !== "_" && cleanText(properties[key]);
  });

  if (!hasCustomSelection) {
    delete properties._custom_option_title_map;
  }

  target
    .querySelectorAll('input[type="hidden"][name^="properties["]')
    .forEach((input) => {
      const key = getPropertyKeyFromField(input);
      if (!key) return;

      handledKeys.add(key);

      if (Object.prototype.hasOwnProperty.call(properties, key)) {
        input.value = cleanText(properties[key]);
        input.disabled = !input.value;
        return;
      }

      input.value = "";
      input.disabled = true;
    });

  Object.entries(properties).forEach(([key, value]) => {
    if (handledKeys.has(key)) return;

    const cleanKey = cleanText(key);
    const cleanValue = cleanText(value);

    if (!cleanKey || !cleanValue) return;

    const input = document.createElement("input");
    input.type = "hidden";
    input.id = `synced_prop_${toHiddenPropertyId(cleanKey)}`;
    input.name = `properties[${cleanKey}]`;
    input.value = cleanValue;
    target.appendChild(input);
  });

  return properties;
}

/* =========================
   DETAIL HELPERS
========================= */
function isColorKey(key) {
  const cleanKey = String(key || "").toLowerCase().trim();

  return (
    cleanKey === "select color" ||
    cleanKey === "select powder coat" ||
    cleanKey === "color" ||
    cleanKey === "colour" ||
    cleanKey.indexOf("select powder coat") !== -1
  );
}

function isTextureKey(key) {
  const cleanKey = String(key || "").toLowerCase().trim();

  if (isPreWeatheringFinishKey(cleanKey)) return false;
  if (isCustomModificationKey(key)) return false;

  return (
    cleanKey === "texture" ||
    cleanKey === "gfrc texture" ||
    cleanKey === "frp texture" ||
    cleanKey === "powder-coat" ||
    cleanKey === "powder coat" ||
    cleanKey === "select powder coat texture" ||
    cleanKey === "select wood texture" ||
    cleanKey.indexOf("texture") !== -1 ||
    cleanKey.indexOf("finish") !== -1 ||
    cleanKey.indexOf("powder coat texture") !== -1 ||
    cleanKey.indexOf("wood texture") !== -1
  );
}

function isPreWeatheringFinishKey(key) {
  const cleanKey = String(key || "")
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  return cleanKey === "pre weathering finish" || cleanKey === "select pre weathering finish";
}

function isColorTextureSummaryKey(key) {
  const cleanKey = String(key || "").toLowerCase().trim();

  return (
    cleanKey === "color & texture" ||
    cleanKey === "color and texture" ||
    cleanKey === "color texture" ||
    cleanKey === "colour & texture" ||
    cleanKey === "colour and texture"
  );
}

function getQuoteDetailCanonicalKey(key) {
  const cleanKey = cleanText(key)
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const keyMap = {
    "color": "select_color",
    "colour": "select_color",
    "select color": "select_color",
    "select powder coat": "select_color",
    "color texture": "color_texture",
    "color and texture": "color_texture",
    "colour texture": "color_texture",
    "colour and texture": "color_texture",
    "wood": "wood",
    "select wood": "wood",
    "wood color": "custom_wood_color",
    "request custom wood color": "custom_wood_color",
    "custom wood color": "custom_wood_color",
    "other wood species": "custom_wood_color",
    "custom wood species": "custom_wood_color",
    "request custom wood species": "custom_wood_color",
    "other gfrc textures": "custom_gfrc_texture",
    "other frp textures": "custom_frp_texture",
    "custom color": "custom_color",
    "request custom color": "custom_color",
    "custom length": "custom_length",
    "custom width": "custom_width",
    "custom height": "custom_height",
    "custom diameter": "custom_diameter",
    "custom depth": "custom_depth",
    "gfrc texture": "texture",
    "frp texture": "texture",
    "pre weathering finish": "texture",
    "powder coat": "texture",
    "powder-coat": "texture",
    "texture": "texture",
    "drainage": "drainage_holes",
    "drain hole": "drainage_holes",
    "drain holes": "drainage_holes",
    "drainhole": "drainage_holes",
    "drainholes": "drainage_holes",
    "drainage holes": "drainage_holes",
    "select drainage holes": "drainage_holes",
    "select drain hole": "drainage_holes",
    "select drainhole": "drainage_holes",
    "irrigation": "irrigation_insert",
    "irrigation insert": "irrigation_insert",
    "container irrigation": "irrigation_insert",
    "scoop": "scoops",
    "scoops": "scoops",
    "caster": "casters",
    "casters": "casters",
    "matching saucer": "matching_saucer",
    "accessory pocket": "accessory_pocket",
    "accessory pockets": "accessory_pocket",
    "false bottom": "false_bottom",
    "bottom reinforcement": "bottom_reinforcement",
    "lift channels": "lift_channels",
    "skate stops": "skate_stops",
    "tie downs": "tie_downs",
    "tourneseal": "tourneseal",
    "waterproofing": "tourneseal",
    "anchor plate": "anchor_plate",
    "toe kick": "toe_kick"
  };

  return keyMap[cleanKey] || cleanKey;
}

function getQuoteDetailDisplayKey(key) {
  const cleanKey = cleanText(key);
  const canonicalKey = getQuoteDetailCanonicalKey(cleanKey);

  if (isCustomModificationKey(cleanKey)) {
    return cleanKey.replace(/^Select\s+/i, "");
  }

  const displayMap = {
    select_color: "Select Color",
    color_texture: "Color & Texture",
    wood: "Wood",
    texture: "Texture",
    drainage_holes: "Drainage Holes",
    irrigation_insert: "Irrigation System",
    material: "Material",
    shape: "Shape",
    length: "Length",
    width: "Width",
    height: "Height",
    depth: "Depth",
    diameter: "Diameter",
    scoops: "Scoops",
    casters: "Casters",
    matching_saucer: "Matching Saucer",
    accessory_pocket: "Accessory Pockets",
    false_bottom: "False Bottom",
    bottom_reinforcement: "Bottom Reinforcement",
    lift_channels: "Lift Channels",
    skate_stops: "Skate Stops",
    tie_downs: "Tie Downs",
    tourneseal: "Tourneseal",
    anchor_plate: "Anchor Plate",
    toe_kick: "Toe Kick"
  };

  if (isPowderCoatKey(cleanKey)) return "Powder-Coat";
  return displayMap[canonicalKey] || cleanKey.replace(/^Select\s+/i, "");
}

function normalizeQuoteDetailValue(key, value) {
  const cleanValue = cleanText(value);

  if (!cleanValue) return "";
  if (isColorTextureSummaryKey(key)) {
    if (/^(?:decide later|tbd|tbd texture)$/i.test(cleanValue) || /,?\s*TBD Texture$/i.test(cleanValue)) {
      return "Decide Later";
    }
    return cleanValue;
  }

  return cleanValue;
}

function isQuoteBooleanYesValue(value) {
  const normalized = cleanText(value).toLowerCase();
  return normalized === "yes" || normalized === "true" || normalized === "on";
}

function renderQuoteRowText(row) {
  const value = cleanText(row.value);

  if (isPowderCoatKey(row.key) || isWoodKey(row.key) || isWoodKey(row.rawKey)) {
    return value;
  }

  const label = getQuoteDetailDisplayKey(row.key);

  return `${label}: ${value}`;
}

function isGroupedQuoteProductOptionKey(key) {
  return [
    "scoops",
    "casters",
    "drainage_holes",
    "irrigation_insert",
    "false_bottom",
    "bottom_reinforcement",
    "tie_downs",
    "tourneseal",
    "anchor_plate",
    "toe_kick",
    "matching_saucer",
    "accessory_pocket",
    "lift_channels",
    "skate_stops"
  ].indexOf(getQuoteDetailCanonicalKey(key)) !== -1;
}

function renderQuoteOptionSwatch(swatch) {
  if (!swatch || (!swatch.image && !swatch.color)) return "";

  if (swatch.image) {
    return `<span class="quote-option-swatch" aria-hidden="true"><img src="${escapeHtml(swatch.image)}" alt=""></span>`;
  }

  return `<span class="quote-option-swatch" aria-hidden="true" style="background: ${escapeHtml(swatch.color)};"></span>`;
}

function quoteRowValueIncludesSwatch(row, swatch) {
  const rowValue = cleanText(row && row.value).toLowerCase();
  const swatchValue = cleanText(swatch && swatch.value).toLowerCase();

  if (!rowValue || !swatchValue) return false;

  return rowValue === swatchValue || rowValue.indexOf(swatchValue) !== -1;
}

function getQuoteItemSwatchForRow(item, row) {
  if (!item || !row) return null;

  const swatches = item.color_swatches || {};
  const textureSwatches = item.texture_swatches || {};
  const canonicalKey = getQuoteDetailCanonicalKey(row.key);
  const cleanKey = cleanText(row.key);

  if (row.isColorTextureSummary) {
    const textureSwatch = Object.values(textureSwatches).find((swatch) => quoteRowValueIncludesSwatch(row, swatch));
    if (textureSwatch) return textureSwatch;

    const swatch = swatches["Color & Texture"] || item.color_swatch || swatches["Select Color"] || swatches["Color"] || null;
    return quoteRowValueIncludesSwatch(row, swatch) ? swatch : null;
  }

  if (swatches[cleanKey]) {
    return quoteRowValueIncludesSwatch(row, swatches[cleanKey]) ? swatches[cleanKey] : null;
  }

  if (textureSwatches[cleanKey]) {
    return quoteRowValueIncludesSwatch(row, textureSwatches[cleanKey]) ? textureSwatches[cleanKey] : null;
  }

  if (canonicalKey === "select_color") {
    const swatch = swatches["Select Powder Coat"] || swatches["Select Color"] || swatches["Color"] || item.color_swatch || null;
    return quoteRowValueIncludesSwatch(row, swatch) ? swatch : null;
  }

  if (isWoodKey(row.key) || isWoodKey(row.rawKey) || (canonicalKey === "wood" && !isCustomModificationKey(row.key) && !isCustomModificationKey(row.rawKey))) {
    const swatch = swatches["Select Wood"] || swatches["Wood"] || null;
    if (!swatch) return null;
    return quoteRowValueIncludesSwatch(row, swatch) ? swatch : null;
  }

  if (canonicalKey === "texture") {
    const swatch = textureSwatches["Texture"] || Object.values(textureSwatches)[0] || null;
    return quoteRowValueIncludesSwatch(row, swatch) ? swatch : null;
  }

  return null;
}

function isCustomDimensionPlaceholderValue(value) {
  const cleanValue = cleanText(value).toLowerCase();

  return (
    cleanValue === "custom" ||
    cleanValue === "custom length" ||
    cleanValue === "custom width" ||
    cleanValue === "custom height" ||
    cleanValue === "custom diameter" ||
    cleanValue === "custom depth"
  );
}

function getDimensionSortOrder(row) {
  const key = String(row && row.key ? row.key : "").toLowerCase();

  if (key.indexOf("diameter") !== -1) return 0;
  if (key.indexOf("length") !== -1) return 1;
  if (key.indexOf("width") !== -1) return 2;
  if (key.indexOf("height") !== -1) return 3;
  if (key.indexOf("depth") !== -1) return 4;

  return 99;
}

function getDimensionAbbreviation(key) {
  const canonicalKey = getQuoteDetailCanonicalKey(key);

  if (canonicalKey === "diameter" || canonicalKey === "custom_diameter") return "Dia.";
  if (canonicalKey === "length" || canonicalKey === "custom_length") return "L";
  if (canonicalKey === "width" || canonicalKey === "custom_width") return "W";
  if (canonicalKey === "height" || canonicalKey === "custom_height") return "H";
  if (canonicalKey === "depth" || canonicalKey === "custom_depth") return "D";

  return "";
}

function formatQuoteDimensionValue(key, value) {
  const cleanValue = cleanText(value);
  const abbreviation = getDimensionAbbreviation(key);

  if (!cleanValue) return "";
  if (!abbreviation) {
    const numericDimensions = cleanValue.split(/\s*(?:\/|x)\s*/i);
    if (numericDimensions.length === 3 && numericDimensions.every((part) => /^\d+(?:\.\d+)?["”]?$/.test(part.trim()))) {
      return numericDimensions
        .map((part, index) => `${part.trim().replace(/["”]$/, "")}"${['L', 'W', 'H'][index]}`)
        .join(" / ");
    }
    return cleanValue;
  }
  if (/(?:dia\.?|[lwhd])\s*$/i.test(cleanValue)) return cleanValue;
  if (/["”]$/.test(cleanValue)) return `${cleanValue}${abbreviation}`;
  if (/^\d+(?:\.\d+)?$/.test(cleanValue)) return `${cleanValue}"${abbreviation}`;

  return `${cleanValue} ${abbreviation}`;
}

/* =========================
   BUILD DETAIL ROWS
========================= */
function getItemDetailRows(item) {
  const variantTitleForDetails = getDisplayVariantTitle(item);
  const properties = removeQuoteVariantOptionProperties(item.properties || {}, item.options || {}, variantTitleForDetails);
  const rows = [];
  const used = new Set();

  let colorValue = "";
  let textureValue = "";
  let colorTextureSummary = "";
  let hasFinishSelection = false;
  const finishValues = [];

  Object.entries(properties).forEach(([key, value]) => {
    const cleanKey = cleanText(key);
    const cleanValue = cleanText(value);
    const keyLower = cleanKey.toLowerCase();

    if (!cleanValue) return;

    if (
      keyLower === "powder-coat" ||
      keyLower === "powder coat" ||
      keyLower === "select powder coat"
    ) {
      hasFinishSelection = true;
      finishValues.push(cleanValue.toLowerCase());
    } else if (
      keyLower === "wood" ||
      keyLower === "select wood"
    ) {
      finishValues.push(cleanValue.toLowerCase());
    }

    if (isColorTextureSummaryKey(key)) {
      colorTextureSummary = cleanValue;
    }

    if (!colorValue && isColorKey(key)) {
      colorValue = cleanValue;
    }

    if (!textureValue && isTextureKey(key) && cleanValue !== "Decide Later") {
      textureValue = cleanValue;
    }

  });

  const colorIsDecideLater = colorValue.toLowerCase() === "decide later";
  const textureIsDecideLater = textureValue.toLowerCase() === "decide later";

  if (hasFinishSelection) {
    colorTextureSummary = "";
  } else if (colorIsDecideLater && textureIsDecideLater) {
    colorTextureSummary = "Decide Later";
  } else if (colorValue && textureValue) {
    colorTextureSummary = buildColorTextureSummary(colorValue, textureValue);
  } else if (colorIsDecideLater) {
    colorTextureSummary = "Decide Later";
  } else if (textureIsDecideLater) {
    colorTextureSummary = "Decide Later";
  } else if (!colorTextureSummary && colorValue) {
    colorTextureSummary = colorValue;
  } else if (!colorTextureSummary && textureValue) {
    colorTextureSummary = textureValue;
  } else if (colorTextureSummary) {
    colorTextureSummary = cleanText(colorTextureSummary.replace(/([a-z])([A-Z])/g, "$1 $2"));
  }

  function pushRow(key, value, extraData = {}) {
    let cleanKey = cleanText(key);
    let cleanValue = normalizeQuoteDetailValue(cleanKey, value);
    const abbreviationKeyMap = {
      "dia": "Diameter",
      "dia.": "Diameter",
      "l": "Length",
      "w": "Width",
      "h": "Height",
      "d": "Depth"
    };
    const abbreviationKey = abbreviationKeyMap[cleanValue.toLowerCase()];

    if (abbreviationKey && !getDimensionAbbreviation(cleanKey)) {
      cleanValue = cleanKey;
      cleanKey = abbreviationKey;
    }

    if (!cleanKey || !cleanValue) return;
    if (isQuoteOnlyDecisionPlaceholder(cleanValue)) return;
    if (cleanKey === "__addonprice") return;
    if (hasFinishSelection && isColorTextureSummaryKey(cleanKey)) return;
    if (hasFinishSelection && !isPowderCoatOrWoodKey(cleanKey) && isTextureKey(cleanKey) && finishValues.indexOf(cleanValue.toLowerCase()) !== -1) return;
    if (isColorTextureSummaryKey(cleanKey) && !extraData.isColorTextureSummary) return;
    if (colorTextureSummary && isTextureKey(cleanKey) && !extraData.isColorTextureSummary) return;
    if (colorTextureSummary && isGenericGroupedColorTextureLabel(cleanKey) && !extraData.isColorTextureSummary) return;
    if (isCustomDimensionPlaceholderValue(cleanValue)) return;

    const keyLower = cleanKey.toLowerCase();

    if (keyLower.charAt(0) === "_" && keyLower !== "_sub color") return;

    const canonicalKey = getQuoteDetailCanonicalKey(cleanKey);

    const uniqueKey = `${canonicalKey}::${cleanValue.toLowerCase()}`;
    if (used.has(uniqueKey)) return;

    used.add(uniqueKey);

    rows.push({
      key: getQuoteDetailDisplayKey(cleanKey),
      rawKey: cleanKey,
      value: cleanValue,
      ...extraData
    });
  }

  Object.entries(item.options || {}).forEach(([k, v]) => {
    let optionValue = v;
    let optionKey = k;
    const cleanOptionValue = cleanText(optionValue);

    if (
      cleanOptionValue &&
      variantTitleForDetails &&
      variantTitleForDetails.toLowerCase().indexOf(cleanOptionValue.toLowerCase()) !== -1
    ) {
      return;
    }

    if (isCustomDimensionPlaceholderValue(optionValue)) {
      const canonicalKey = getQuoteDetailCanonicalKey(k).replace(/^custom_/, '');
      const matchingProperty = Object.entries(properties).find(([propertyKey, propertyValue]) => {
        const propertyCanonicalKey = getQuoteDetailCanonicalKey(propertyKey).replace(/^custom_/, '');
        return propertyCanonicalKey === canonicalKey && cleanText(propertyValue) &&
          !isCustomDimensionPlaceholderValue(propertyValue);
      });
      if (matchingProperty) {
        optionValue = matchingProperty[1];
        optionKey = `Custom ${k}`;
      }
    }
    const optionDimensionKey = getQuoteDetailCanonicalKey(k).replace(/^custom_/, '');
    const customDimensionProperty = Object.entries(properties).find(([propertyKey, propertyValue]) => {
      return getQuoteDetailCanonicalKey(propertyKey) === `custom_${optionDimensionKey}` &&
        cleanText(propertyValue) && !isCustomDimensionPlaceholderValue(propertyValue);
    });
    if (customDimensionProperty) {
      optionValue = customDimensionProperty[1];
      optionKey = `Custom ${k}`;
    }
    pushRow(optionKey, optionValue);
  });

  if (colorTextureSummary) {
    colorTextureSummary = normalizeQuoteDetailValue("Color & Texture", colorTextureSummary);
    pushRow("Color & Texture", colorTextureSummary, {
      isColorTextureSummary: true
    });
  }

  Object.entries(properties).forEach(([k, v]) => {
    pushRow(k, v);
  });

  const currentOrder = getCurrentCustomOptionOrder();
  const savedOrder = getCustomOptionOrderFromSource(properties._custom_option_order);
  const rowOrder = savedOrder.length ? savedOrder : currentOrder;

  rows.sort((a, b) => {
    const order = rowOrder;
    const rankA = getPropertyRank(a.key, order);
    const rankB = getPropertyRank(b.key, order);

    if (rankA !== -1 || rankB !== -1) {
      if (rankA === -1) return 1;
      if (rankB === -1) return -1;
      if (rankA !== rankB) return rankA - rankB;
    }

    return 0;
  });

  return rows;
}

/* =========================
   RENDER DETAIL HTML
========================= */
function renderItemDetails(item, index, options = {}) {
  const rows = getItemDetailRows(item);
  const customDimensionRows = Object.entries(item.properties || {})
    .filter(([key, value]) => /^custom\s+(length|width|height|diameter|depth)$/i.test(String(key).trim()) && cleanText(value))
    .map(([key, value]) => ({ rawKey: key, key, value: cleanText(value) }));
  const hasCustomDimensionRows = customDimensionRows.length > 0 || rows.some((row) =>
    /^custom\s+(length|width|height|diameter|depth)$/i.test(String(row.rawKey || row.key || '').trim())
  );
  const storedDimensionSummary = normalizeCustomDimensionSummary(
    item.custom_dimensions_summary || (item.properties && item.properties._custom_dimensions_summary)
  );
  let variantTitle = getDisplayVariantTitle(item);
  if (variantTitle) variantTitle = formatNumericVariantDimensions(variantTitle);

  if (!rows.length && !variantTitle) {
    return `<div class="quote-options"></div>`;
  }

  const allDimensionRows = rows.filter((row) => getDimensionSortOrder(row) !== 99);
  const colorTextureSummaryRow = rows.find((row) => row.isColorTextureSummary);
  const shownKeys = new Set();
  const dimensionRowsForSummary = customDimensionRows.length ? customDimensionRows : allDimensionRows;
  const dimensionSummary = (hasCustomDimensionRows && storedDimensionSummary) || (
    dimensionRowsForSummary.length && hasCustomDimensionRows
      ? dimensionRowsForSummary
          .slice()
          .sort((a, b) => getDimensionSortOrder(a) - getDimensionSortOrder(b))
          .map((row) => {
            const dimensionKey = row.rawKey || row.key;
            return formatQuoteDimensionValue(dimensionKey, row.value);
          })
          .filter(Boolean)
          .join(" / ")
      : ""
  );

  if (variantTitle || dimensionSummary) {
    allDimensionRows.forEach((row) => shownKeys.add(row.key));
  }

  if (colorTextureSummaryRow) {
    shownKeys.add(colorTextureSummaryRow.key);
  }

  const appearanceRows = rows
    .filter((row) => {
      if (shownKeys.has(row.key)) return false;

      const key = String(row.key || "").toLowerCase();
      const rawKey = String(row.rawKey || "").toLowerCase();
      const canonicalKey = getQuoteDetailCanonicalKey(row.key);

      if (isCustomModificationKey(row.key) || isCustomModificationKey(row.rawKey) || isCustomModificationKey(canonicalKey)) {
        return false;
      }

      const isWoodRow = isWoodKey(row.key) || isWoodKey(row.rawKey) || isPowderCoatOrWoodDecisionKey(row.key) || isPowderCoatOrWoodDecisionKey(row.rawKey) || (canonicalKey === "wood" && !isCustomModificationKey(row.key) && !isCustomModificationKey(row.rawKey));
      const isFinishRow = isPowderCoatKey(row.key) || isPowderCoatKey(row.rawKey) || isPowderCoatOrWoodDecisionKey(row.key) || isPowderCoatOrWoodDecisionKey(row.rawKey);

      if (!isFinishRow && !isWoodRow && (isColorKey(key) || isTextureKey(key) || isColorTextureSummaryKey(key))) {
        return false;
      }

      return (
        isFinishRow ||
        isWoodRow ||
        key.indexOf("coat") !== -1 ||
        (key.indexOf("finish") !== -1 && key.indexOf("pre weathering") !== -1) ||
        canonicalKey === "material"
      );
    })
    .slice(0, 3);

  appearanceRows.forEach((row) => shownKeys.add(row.key));

  const finishValues = appearanceRows
    .filter((row) => isPowderCoatOrWoodKey(row.key) || isPowderCoatOrWoodDecisionKey(row.key))
    .map((row) => cleanText(row.value).toLowerCase())
    .filter(Boolean);

  const moreRows = rows.filter((row) => {
    if (shownKeys.has(row.key)) return false;

    const key = String(row.key || "").toLowerCase();
    const value = cleanText(row.value).toLowerCase();

    if (finishValues.length && isTextureKey(key) && finishValues.indexOf(value) !== -1) {
      return false;
    }

    return true;
  });

  const groupedProductOptionRows = [];
  const remainingMoreRows = [];

  moreRows.forEach((row) => {
    if (isGroupedQuoteProductOptionKey(row.rawKey || row.key)) {
      if (options.hideGroupedProductOptions) return;
      groupedProductOptionRows.push(row);
      return;
    }

    remainingMoreRows.push(row);
  });

  const variantTitleHtml = variantTitle
    ? `<div class="quote-option quote-option--summary">${escapeHtml(variantTitle)}</div>`
    : "";
  const normalizeSummaryText = (value) => cleanText(value).toLowerCase().replace(/\s+/g, " ");
  const dimensionSummaryHtml = dimensionSummary && normalizeSummaryText(dimensionSummary) !== normalizeSummaryText(variantTitle)
    ? `<div class="quote-option quote-option--summary">${escapeHtml(dimensionSummary)}</div>`
    : "";

  const swatchHtml = renderQuoteOptionSwatch(getQuoteItemSwatchForRow(item, colorTextureSummaryRow));
  const colorTextureHtml = colorTextureSummaryRow
    ? `<div class="quote-option quote-option--summary quote-option--color-texture"><span>${escapeHtml(colorTextureSummaryRow.value)}</span>${swatchHtml}</div>`
    : "";

  const appearanceHtml = appearanceRows
    .map((row) => {
      const label = renderQuoteRowText(row);
      return `<div class="quote-option quote-option--appearance"><span>${escapeHtml(label)}</span>${renderQuoteOptionSwatch(getQuoteItemSwatchForRow(item, row))}</div>`;
    })
    .join("");

  let toggleHtml = "";
  let hiddenHtml = "";

  if (remainingMoreRows.length > 0 || groupedProductOptionRows.length > 0) {
    const groupedProductOptionsHtml = groupedProductOptionRows.length
      ? `<div class="quote-option quote-option--product-options">${groupedProductOptionRows
          .map((row) => `${escapeHtml(row.key)}: ${escapeHtml(row.value)}`)
          .join(", ")}</div>`
      : "";

    const moreHtml = remainingMoreRows
      .map((row) => `<div class="quote-option">${escapeHtml(renderQuoteRowText(row))}</div>`)
      .join("");

    hiddenHtml = `<div class="quote-more-content" data-index="${index}" hidden>${groupedProductOptionsHtml}${moreHtml}</div>`;
    toggleHtml = getToggleButtonHtml(index, false);
  }

  return `
    <div class="quote-options">
      ${variantTitleHtml}
      ${dimensionSummaryHtml}
      ${colorTextureHtml}
      ${appearanceHtml}
      ${hiddenHtml}
      ${toggleHtml}
    </div>
  `;
}

/* =========================
   SELECTED OPTION IMAGE FOR QUOTE
========================= */
function normalizeImageUrl(url) {
  url = cleanText(url);
  if (!url) return "";
  if (url.indexOf("no-image") !== -1 || url.indexOf("blank") !== -1) return "";

  try {
    return new URL(url, window.location.origin).href;
  } catch (e) {
    return url;
  }
}

function getImageFromElement(image) {
  if (!image) return "";

  return normalizeImageUrl(
    image.getAttribute("data-src") ||
      image.getAttribute("data-media-src") ||
      image.currentSrc ||
      image.getAttribute("src") ||
      image.src ||
      ""
  );
}

function getImageFromLabel(input) {
  if (!input || !input.id) return "";

  const label = document.querySelector(`label[for="${quoteCssEscape(input.id)}"]`);
  const image = label ? label.querySelector("img") : null;

  return getImageFromElement(image);
}

function getDefaultProductImage(context) {
  const scope = context && typeof context.closest === "function"
    ? (context.closest("[data-default-quote-image]") || context.closest("[data-section-id]") || document)
    : document;

  const holder = scope && scope.querySelector
    ? (scope.matches && scope.matches("[data-default-quote-image]") ? scope : scope.querySelector("[data-default-quote-image]"))
    : document.querySelector("[data-default-quote-image]");

  const imageFromLiquid = normalizeImageUrl(holder ? holder.getAttribute("data-default-quote-image") : "");

  if (imageFromLiquid) return imageFromLiquid;

  const productImages = (scope && scope.querySelectorAll ? scope : document).querySelectorAll(
    [
      "#MainContent .product__media-list img",
      "#MainContent media-gallery img",
      "#MainContent .product__media img",
      "#MainContent .product-media img",
      "#MainContent .image-detail",
      ".product__media-list img",
      "media-gallery img",
      ".product__media img",
      ".product-media img",
      ".image-detail"
    ].join(", ")
  );

  for (const image of productImages) {
    const imageUrl = getImageFromElement(image);
    if (imageUrl) return imageUrl;
  }

  return "";
}

function markExplicitQuoteImageSelection(input) {
  if (!input) return;

  const groupName = input.getAttribute("name");
  if (groupName) {
    document.querySelectorAll(`input[name="${groupName.replace(/"/g, '\\"')}"]`).forEach((field) => {
      field.removeAttribute("data-quote-image-explicit");
    });
  }

  input.setAttribute("data-quote-image-explicit", "true");
}

function getSelectedQuoteImage(variant, context) {
  const defaultImage = getDefaultProductImage(context);
  if (defaultImage) return defaultImage;

  if (variant && variant.featured_image && variant.featured_image.src) {
    const variantImage = normalizeImageUrl(variant.featured_image.src);
    if (variantImage) return variantImage;
  }

  return "";
}

/* =========================
   ADD TO QUOTE
========================= */
function parseQuoteJson(value, fallback) {
  if (!value) return fallback;

  try {
    const parsed = JSON.parse(value);
    return parsed === null || parsed === undefined ? fallback : parsed;
  } catch (e) {
    return fallback;
  }
}

function getCurrentQuoteQuantity(triggerButton) {
  const scopedRoot =
    (triggerButton && triggerButton.closest && triggerButton.closest(".product-info")) ||
    document.querySelector(".product-info") ||
    document;

  const isVisibleInput = (input) => {
    if (!input) return false;
    if (input.disabled) return false;
    if (input.type === "hidden") return false;

    const style = window.getComputedStyle ? window.getComputedStyle(input) : null;
    if (style && (style.display === "none" || style.visibility === "hidden")) {
      return false;
    }

    if (input.offsetParent === null && style && style.position !== "fixed") {
      return false;
    }

    return true;
  };

  const getVisibleQuantityInput = (root) => {
    if (!root || typeof root.querySelectorAll !== "function") return null;

    const inputs = Array.from(root.querySelectorAll('input[name="quantity"], input[type="number"][name="quantity"]'));
    return inputs.find(isVisibleInput) || null;
  };

  const nearestContainer =
    (triggerButton && triggerButton.closest && (
      triggerButton.closest('form[data-type="add-to-cart-form"]') ||
      triggerButton.closest(".product-form__buttons") ||
      triggerButton.closest(".product-info")
    )) ||
    scopedRoot;

  const quantityInput =
    getVisibleQuantityInput(nearestContainer) ||
    getVisibleQuantityInput(scopedRoot) ||
    getVisibleQuantityInput(document);

  const quantity = Number(quantityInput && quantityInput.value);
  return quantity > 0 ? quantity : 1;
}

function getCardVariantOptions(button) {
  const productOptions = parseQuoteJson(button.getAttribute("data-product-options"), []);
  const variantOptions = parseQuoteJson(button.getAttribute("data-variant-options"), []);
  const options = {};

  if (!Array.isArray(variantOptions)) return options;

  variantOptions.forEach((value, index) => {
    const cleanValue = cleanText(value);

    if (!cleanValue || cleanValue === "Default Title") return;

    const label = cleanText(Array.isArray(productOptions) ? productOptions[index] : "") || "Option " + (index + 1);
    options[label] = cleanValue;
  });

  return options;
}

function addQuoteItemToBasket(newItem, triggerButton) {
  let quoteItems = getQuoteItems();
  const quantity = Number(newItem.qty || 1) || 1;
  const newKey =
    newItem.variant_id +
    "_" +
    normalizeOptions(newItem.options || {}) +
    "_" +
    normalizeProperties(newItem.properties || {});

  const existingIndex = quoteItems.findIndex((item) => {
    const itemKey =
      item.variant_id +
      "_" +
      normalizeOptions(item.options || {}) +
      "_" +
      normalizeProperties(item.properties || {});

    return itemKey === newKey;
  });

  if (existingIndex > -1) {
    quoteItems[existingIndex].qty = (Number(quoteItems[existingIndex].qty) || 0) + quantity;

    if (newItem.image) {
      quoteItems[existingIndex].image = newItem.image;
    }
  } else {
    quoteItems.push(newItem);
  }

  mergeLinkedQuoteItems(quoteItems, getSelectedLinkedQuoteItems(triggerButton, newItem));

  setQuoteItems(quoteItems);
  openQuote();
}

function mergeLinkedQuoteItems(quoteItems, linkedItems) {
  linkedItems.forEach((linkedItem) => {
    const linkedKey = getQuoteItemKey(linkedItem);
    const linkedIndex = quoteItems.findIndex((item) => {
      return getQuoteItemKey(item) === linkedKey;
    });

    if (linkedIndex > -1) {
      quoteItems[linkedIndex].qty = (Number(quoteItems[linkedIndex].qty) || 0) + (Number(linkedItem.qty) || 1);
      quoteItems[linkedIndex].properties = {
        ...(quoteItems[linkedIndex].properties || {}),
        ...(linkedItem.properties || {})
      };
    } else {
      quoteItems.push(linkedItem);
    }
  });
}

function getLinkedVariantPropertiesFromInput(input) {
  const productOptions = parseLinkedJson(input.getAttribute("data-linked-product-options"));
  const variantOptions = parseLinkedJson(input.getAttribute("data-linked-variant-options"));
  const properties = {};

  if (!Array.isArray(productOptions) || !Array.isArray(variantOptions)) return properties;

  productOptions.forEach((name, index) => {
    let optionName = cleanText(name);
    let optionValue = cleanText(variantOptions[index]);

    if (!optionName || !optionValue || optionValue === "Default Title") return;
    if (optionName === optionValue || /^\d+(?:\.\d+)?$/.test(optionName)) {
      optionName = ["Diameter", "Height", "Length"][index] || `Option ${index + 1}`;
    }
    if (/^(?:dia\.?|l|w|h|d)$/i.test(optionValue) && !/^(?:diameter|length|width|height|depth)$/i.test(optionName)) {
      const labelMap = {
        "dia": "Diameter",
        "dia.": "Diameter",
        "l": "Length",
        "w": "Width",
        "h": "Height",
        "d": "Depth"
      };
      const nextOptionName = labelMap[optionValue.toLowerCase()];
      optionValue = optionName;
      optionName = nextOptionName || optionName;
    }

    properties[optionName] = optionValue;
  });

  return properties;
}

function getLinkedParentDisplayProperties(parentItem, input) {
  const parentProperties = removeQuoteOptionSnapshotProperties((parentItem && parentItem.properties) || {});
  const linkedOptionName = cleanText(input && input.getAttribute("data-option-name"));
  const linkedOptionKey = getQuoteDetailCanonicalKey(linkedOptionName);
  const displayProperties = {};

  Object.entries(parentProperties).forEach(([key, value]) => {
    const cleanKey = cleanText(key);
    const cleanValue = cleanText(value);

    if (!cleanKey || !cleanValue) return;
    if (cleanKey.charAt(0) === "_") return;
    if (linkedOptionKey && getQuoteDetailCanonicalKey(cleanKey) === linkedOptionKey) return;

    displayProperties[cleanKey] = cleanValue;
  });

  return displayProperties;
}

function getSelectedLinkedQuoteItems(triggerButton, parentItem) {
  const root =
    (triggerButton && triggerButton.closest && (triggerButton.closest("[data-section-id]") || triggerButton.closest(".product-info"))) ||
    document;
  const parentTitle = cleanText(parentItem && parentItem.product_title);
  const parentVariantId = parentItem && parentItem.variant_id;
  const parentQuoteKey = getQuoteItemKey(parentItem);
  const parentStorageKey = getQuoteStorageItemKey(parentItem);
  const seen = new Set();
  const linkedItems = [];

  const isUsableLinkedInput = (input) => {
    if (!input || input.disabled) return false;
    if (input.closest("[data-aggregate-preview-root], [data-initial-aggregate-normal-options], [data-initial-aggregate-custom-modifications], [data-initial-aggregate-color-preview]")) return false;

    const hiddenBlock = input.closest("[hidden], [aria-hidden='true']");
    if (hiddenBlock) return false;

    const liveBlock = input.closest("[data-live-normal-metafield-options], [data-live-custom-modification-options], [data-live-variant-color-options]");
    if (liveBlock && (liveBlock.hidden || liveBlock.style.display === "none")) return false;

    const item = input.closest(".block-addon-option__item, .color-dependent-option, .block-color-texture-card__color-item, .block-color-texture-card__texture-item");
    if (item && (item.hidden || item.style.display === "none" || item.classList.contains("hidden"))) return false;

    return true;
  };
  const isIrrigationLinkedInput = (input) => {
    const optionKey = cleanText(input && input.getAttribute("data-option-key")).toLowerCase();
    const optionName = cleanText(input && input.getAttribute("data-option-name")).toLowerCase();
    const productTitle = cleanText(input && input.getAttribute("data-linked-product-title")).toLowerCase();

    return optionKey.indexOf("irrig") !== -1 || optionName.indexOf("irrig") !== -1 || productTitle.indexOf("irrig") !== -1;
  };
  const isWillardKitLinkedInput = (input) => {
    const optionKey = cleanText(input && input.getAttribute("data-option-key")).toLowerCase();
    const optionName = cleanText(input && input.getAttribute("data-option-name")).toLowerCase();
    const combined = `${optionKey} ${optionName}`;
    return combined.indexOf("willard") !== -1 ||
      combined.indexOf("anchoring kit") !== -1 ||
      combined.indexOf("joining kit") !== -1;
  };
  const selectedInputs = Array.from(document.querySelectorAll(".custom-option-radio[data-linked-variant-id]:checked")).filter((input) => {
    if (!input || input.disabled) return false;
    return isUsableLinkedInput(input) || isIrrigationLinkedInput(input);
  });

  let selectedIrrigationValue = "";
  if (parentItem && parentItem.properties) {
    for (const [k, v] of Object.entries(parentItem.properties)) {
      if (k.toLowerCase().indexOf("irrig") !== -1) {
        const val = cleanText(v).toLowerCase();
        if (val && val !== "no" && val !== "false" && val !== "off" && val !== "none") {
          selectedIrrigationValue = val;
          break;
        }
      }
    }
  }

  // Find any matching irrigation input even if re-rendered or in live/preview blocks
  document.querySelectorAll(".custom-option-radio[data-linked-variant-id]").forEach((input) => {
    if (!isIrrigationLinkedInput(input)) return;
    if (input.disabled) return;

    const optionValue = cleanText(
      input.getAttribute("data-option-value") ||
      input.getAttribute("data-option-label") ||
      input.value
    ).toLowerCase();

    const isMatch = selectedIrrigationValue && (optionValue === selectedIrrigationValue || selectedIrrigationValue === "yes" || selectedIrrigationValue === "true");

    if ((input.checked || isMatch) && selectedInputs.indexOf(input) === -1) {
      selectedInputs.push(input);
    }
  });

  selectedInputs.forEach((input) => {
    const linkedVariantId = cleanText(input.getAttribute("data-linked-variant-id"));
    if (!linkedVariantId || seen.has(linkedVariantId)) return;
    if (parentVariantId && String(linkedVariantId) === String(parentVariantId)) return;
    seen.add(linkedVariantId);
    const linkedProductTitle = getLinkedProductDisplayTitle(input);
    const linkedOptionLabel = cleanText(input.getAttribute("data-option-label"));
    const linkedOptionName = cleanText(input.getAttribute("data-option-name"));
    const linkedOptionValue = cleanText(input.getAttribute("data-option-value")) || linkedOptionLabel;
    const isIrrigationLinkedOption = isIrrigationLinkedInput(input);
    const isWillardKitLinkedOption = isWillardKitLinkedInput(input);

    const linkedVariantProperties = getLinkedVariantPropertiesFromInput(input);
    if (isIrrigationLinkedOption || isWillardKitLinkedOption) return;
    const linkedOptions = isIrrigationLinkedOption ? linkedVariantProperties : {};
    const linkedProperties = {
      ...(!isIrrigationLinkedOption ? { "For": parentTitle } : {}),
      ...(!isIrrigationLinkedOption ? getLinkedParentDisplayProperties(parentItem, input) : {}),
      ...(!isIrrigationLinkedOption && linkedOptionName && linkedOptionValue ? { [linkedOptionName]: linkedOptionValue } : {}),
      ...(!isIrrigationLinkedOption ? linkedVariantProperties : {}),
      "_parent_variant_id": parentVariantId,
      "_parent_quote_key": parentQuoteKey,
      "_parent_storage_key": parentStorageKey
    };

    linkedItems.push({
      variant_id: Number(linkedVariantId) || linkedVariantId,
      sku: cleanText(input.getAttribute("data-linked-variant-sku") || input.getAttribute("data-linked-product-sku")),
      product_title: linkedProductTitle && linkedProductTitle.toLowerCase() !== "default title" ? linkedProductTitle : linkedOptionLabel || "Linked Product",
      image: normalizeImageUrl(input.getAttribute("data-linked-product-image")),
      options: linkedOptions,
      properties: linkedProperties,
      qty: Number(parentItem && parentItem.qty) || 1,
      product_url: input.getAttribute("data-linked-product-url") || "",
      price: input.getAttribute("data-linked-product-price") || ""
    });
  });

  return linkedItems;
}

function validateCustomDimensionsForQuote(event) {
  if (
    window.CustomDimensionsValidator &&
    typeof window.CustomDimensionsValidator.validateBeforeAction === "function"
  ) {
    if (window.CustomDimensionsValidator.validateBeforeAction(event) === false) {
      return false;
    }
  }

  return validateVisibleDimensionsFallback(event);
}

function isElementVisible(element) {
  return !!(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
}

function isValidDimensionNumber(value) {
  const sanitized = String(value || "").replace(/[^0-9.]/g, "");
  return /^\d+(?:\.\d+)?$/.test(sanitized);
}

function getVisibleDimensionsPicker(scope) {
  const scopedRoot = scope && typeof scope.querySelectorAll === "function" ? scope : document;
  let pickers = Array.from(scopedRoot.querySelectorAll('[data-custom-dimensions-picker]:not(.custom-dimensions-picker--cwm-model)')).filter(isElementVisible);

  if (!pickers.length && scopedRoot !== document) {
    pickers = Array.from(document.querySelectorAll('[data-custom-dimensions-picker]:not(.custom-dimensions-picker--cwm-model)')).filter(isElementVisible);
  }

  return (
    pickers.find((picker) => picker.classList.contains("custom-dimensions-picker--customize-active")) ||
    pickers.find((picker) => isDimensionsPickerComplete(picker)) ||
    pickers[0] ||
    null
  );
}

function getDimensionColumnLabel(column) {
  const label = column && column.querySelector(".custom-dimensions-picker__label");

  return cleanText(label ? label.textContent : "");
}

function showDimensionsFallbackError(picker, customMode) {
  const selector = customMode ? "[data-custom-dimensions-error]" : "[data-custom-dimensions-preset-error]";
  const oppositeSelector = customMode ? "[data-custom-dimensions-preset-error]" : "[data-custom-dimensions-error]";
  let error = picker.querySelector(selector);
  const customize = picker.querySelector(".custom-dimensions-picker__customize");

  if (!error) {
    error = document.createElement("p");
    error.className = "custom-dimensions-picker__error";
    error.setAttribute(customMode ? "data-custom-dimensions-error" : "data-custom-dimensions-preset-error", "true");
    error.setAttribute("role", "alert");
    error.setAttribute("aria-live", "polite");
  }

  if (customMode) {
    picker.classList.add("custom-dimensions-picker--customize-active", "custom-dimensions-picker--custom-mode");
    if (customize) {
      customize.classList.add("is-active");
      customize.setAttribute("aria-pressed", "true");
      customize.insertBefore(error, customize.querySelector(".custom-dimensions-picker__customize-fields") || null);
    }
  } else {
    const grid = picker.querySelector(".custom-dimensions-picker__grid");
    if (grid && grid.parentNode) {
      grid.parentNode.insertBefore(error, grid.nextSibling);
    }
  }

  const oppositeError = picker.querySelector(oppositeSelector);
  if (oppositeError) {
    oppositeError.hidden = true;
    oppositeError.classList.remove("is-active");
  }

  const labels = customMode
    ? Array.from(picker.querySelectorAll("[data-store-only-property='true']")).map((field) => {
      const label = field.closest(".custom-dimensions-picker__field")?.querySelector("label");
      return cleanText(label ? label.textContent : "");
    }).filter(Boolean)
    : Array.from(picker.querySelectorAll("[data-dimension-option]")).map(getDimensionColumnLabel).filter(Boolean);

  error.textContent = customMode
    ? `Please enter ${labels.length ? labels.join(", ") : "custom dimensions"}.`
    : `Please select ${labels.length ? labels.join(", ") : "dimensions"} before adding to cart.`;
  error.hidden = false;
  error.classList.add("is-active");
  error.setAttribute("data-error-active", "true");
  picker.classList.toggle("custom-dimensions-picker--has-error", customMode);
  picker.classList.toggle("custom-dimensions-picker--has-preset-error", !customMode);

  (customMode && customize ? customize : picker).scrollIntoView({ behavior: "smooth", block: "center" });
}

function isDimensionsPickerComplete(picker) {
  if (!picker) return true;

  const customMode = picker.classList.contains("custom-dimensions-picker--customize-active") ||
    picker.classList.contains("custom-dimensions-picker--custom-mode") ||
    (window.CustomDimensionsModeState && window.CustomDimensionsModeState[picker.getAttribute("data-dimensions-dedupe-key") || ""] === "custom") ||
    Array.from(picker.querySelectorAll("[data-store-only-property='true']")).some((field) => cleanText(field.value));

  if (customMode) {
    const allFields = Array.from(picker.querySelectorAll("[data-store-only-property='true'], [data-custom-dimension-field]"));
    const activeFields = allFields.filter((field) => field && !field.disabled && (field.offsetWidth || field.offsetHeight || field.getClientRects().length > 0));
    const fieldsToCheck = activeFields.length > 0 ? activeFields : allFields.filter((field) => field && !field.disabled);

    if (!fieldsToCheck.length) return false;

    return fieldsToCheck.every((field) => {
      let value = String(field.value || "").trim();
      const fieldName = field.getAttribute("data-custom-dimension-field");
      if (!value && fieldName && window.CustomDimensionsSavedFieldValues) {
        value = String(window.CustomDimensionsSavedFieldValues[fieldName] || "").trim();
      }
      return isValidDimensionNumber(value);
    });
  }

  const columns = Array.from(picker.querySelectorAll("[data-dimension-option]"));

  return columns.length > 0 && columns.every((column) => {
    const checked = column.querySelector("input[type='radio']:checked:not(:disabled)");
    return !!(checked && cleanText(checked.value));
  });
}

function validateVisibleDimensionsFallback(event) {
  const trigger = event && event.target && event.target.closest ? event.target : null;
  const scopedRoot =
    (trigger && trigger.closest("#quickview-product-content")) ||
    (trigger && trigger.closest(".product-info")) ||
    (trigger && trigger.closest("[data-section-id]")) ||
    document;
  const picker = getVisibleDimensionsPicker(scopedRoot);

  if (!picker || isDimensionsPickerComplete(picker)) return true;

  if (event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
  }

  showDimensionsFallbackError(picker, picker.classList.contains("custom-dimensions-picker--customize-active") || picker.classList.contains("custom-dimensions-picker--custom-mode"));
  return false;
}

function addCardProductToQuote(button) {
  const variantId = button.getAttribute("data-variant-id");

  if (!variantId) {
    console.warn("No variant found for quote card");
    return;
  }

  addQuoteItemToBasket({
    variant_id: Number(variantId) || variantId,
    sku: cleanText(button.getAttribute("data-sku") || button.getAttribute("data-variant-sku")),
    product_title: cleanText(button.getAttribute("data-product-title")),
    variant_title: cleanText(button.getAttribute("data-variant-title")),
    image: normalizeImageUrl(button.getAttribute("data-image")),
    options: getCardVariantOptions(button),
    properties: {},
    qty: 1,
    product_url: button.getAttribute("data-product-url") || "",
    price: button.getAttribute("data-price") || ""
  }, button);
}

function addCurrentProductToQuote(triggerButton) {
  const activeForm =
    triggerButton &&
    triggerButton.closest &&
    triggerButton.closest(".product-info") &&
    triggerButton.closest(".product-info").querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');

  if (activeForm) {
    window.CustomQuoteActiveForm = activeForm;
  }

  if (typeof window.updateAllQuoteHiddenProperties === "function") {
    window.updateAllQuoteHiddenProperties();
  }

  let variant = getCurrentVariant(triggerButton);

  if (!variant) {
    console.warn("No variant found");
    return;
  }

  // A preset size is chosen (custom mode is off): use that variant and drop any
  // custom dimension values left over from an earlier Customize entry.
  const pickerScope = (triggerButton && triggerButton.closest && triggerButton.closest(".product-info")) || document;
  const dimensionPicker = pickerScope.querySelector("[data-custom-dimensions-picker]:not(.custom-dimensions-picker--cwm-model)");
  const pickerState = dimensionPicker && typeof window.__tournesolPickerState === "function"
    ? window.__tournesolPickerState(dimensionPicker)
    : null;
  const usePresetSize = !!(pickerState && !pickerState.customMode);

  if (usePresetSize && pickerState.presetVariant && String(pickerState.presetVariant.id) !== String(variant.id)) {
    variant = { ...variant, ...pickerState.presetVariant };
  }

  const options = getVariantOptions(variant);
  let properties = sanitizeFinishProperties({
    ...removeQuoteOptionSnapshotProperties(getCurrentLineItemProperties()),
    ...buildCurrentColorTextureProperties(triggerButton)
  });

  if (usePresetSize) {
    Object.keys(properties).forEach((key) => {
      const canonical = getQuoteDetailCanonicalKey(key).replace(/\s+/g, "_");
      if (/^custom_(?:diameter|height|length|width|depth)$/.test(canonical) || canonical === "custom_dimensions_summary") {
        delete properties[key];
      }
    });
  }

  const customDimensionSummary = setCustomDimensionProperty(properties, variant.title || "");
  properties = removeQuoteVariantOptionProperties(properties, options, variant.title || "");
  const imageUrl = getSelectedQuoteImage(variant, triggerButton);
  const colorSwatch = getSelectedColorSwatchData(
    (triggerButton && triggerButton.closest && (triggerButton.closest("[data-section-id]") || triggerButton.closest(".product-info"))) || document
  );
  const colorSwatches = getSelectedColorSwatchMap(
    (triggerButton && triggerButton.closest && (triggerButton.closest("[data-section-id]") || triggerButton.closest(".product-info"))) || document
  );
  const textureSwatches = getSelectedTextureSwatchMap(
    (triggerButton && triggerButton.closest && (triggerButton.closest("[data-section-id]") || triggerButton.closest(".product-info"))) || document
  );
  // Internal helper properties are never stored on a quote item either.
  ["_custom_option_order", "_quote_image", "__addonprice", "_color_swatch", "_wood_swatch", "_powder_coat_swatch"].forEach((key) => {
    delete properties[key];
  });
  properties["_quote_signature"] = buildQuoteSelectionSignature(options, properties, imageUrl);
  const quantity = getCurrentQuoteQuantity(triggerButton);

  const productTitle = variant.product_title
    ? variant.product_title
    : variant.name
      ? variant.name.split(" - ")[0]
      : "";

  const newItem = {
    variant_id: variant.id,
    sku: cleanText(variant.sku || variant.variant_sku),
    product_title: productTitle,
    variant_title: getCustomDimensionVariantTitle(properties, variant.title || ""),
    custom_dimensions_summary: customDimensionSummary,
    image: imageUrl,
    options: options,
    properties: properties,
    color_swatch: colorSwatch,
    color_swatches: colorSwatches,
    texture_swatches: textureSwatches,
    qty: quantity,
    product_url: window.location.pathname,
    price: variant.price || ""
  };

  let quoteItems = getQuoteItems();

  const newKey =
    variant.id +
    "_" +
    normalizeOptions(options) +
    "_" +
    normalizeProperties(properties);

  const existingIndex = quoteItems.findIndex((item) => {
    const itemKey =
      item.variant_id +
      "_" +
      normalizeOptions(item.options || {}) +
      "_" +
      normalizeProperties(item.properties || {});

    return itemKey === newKey;
  });

  if (existingIndex > -1) {
    quoteItems[existingIndex].qty = (Number(quoteItems[existingIndex].qty) || 0) + quantity;

    if (imageUrl) {
      quoteItems[existingIndex].image = imageUrl;
    }

    if (colorSwatch) {
      quoteItems[existingIndex].color_swatch = colorSwatch;
    }

    if (colorSwatches && Object.keys(colorSwatches).length) {
      quoteItems[existingIndex].color_swatches = colorSwatches;
    }

    if (textureSwatches && Object.keys(textureSwatches).length) {
      quoteItems[existingIndex].texture_swatches = textureSwatches;
    }

  } else {
    quoteItems.push(newItem);
  }

  mergeLinkedQuoteItems(quoteItems, getSelectedLinkedQuoteItems(triggerButton, newItem));

  setQuoteItems(quoteItems);
  openQuote();
}

/* =========================
   QUOTE POPUP SWIPER SLIDER WITH PROGRESS BAR
========================= */
function getQuoteSwiperIndex() {
  if (!quoteBasketSwiper || typeof quoteBasketSwiper.activeIndex === "undefined") {
    return 0;
  }

  return quoteBasketSwiper.activeIndex || 0;
}

function destroyQuoteSwiper() {
  if (quoteBasketSwiper && typeof quoteBasketSwiper.destroy === "function") {
    quoteBasketSwiper.destroy(true, false);
  }

  quoteBasketSwiper = null;
}

function ensureQuoteSwiperStructure() {
  const content = document.querySelector(".quote-content");
  const track = document.querySelector(".block_quote-popup-info-inner");

  if (!content || !track) return null;

  let swiperEl = content.querySelector(".quote-swiper");

  if (!swiperEl) {
    swiperEl = document.createElement("div");
    swiperEl.className = "quote-swiper swiper";

    track.parentNode.insertBefore(swiperEl, track);
    swiperEl.appendChild(track);
  }

  track.classList.add("swiper-wrapper");

  track.querySelectorAll(".quote-item").forEach((item) => {
    item.classList.add("swiper-slide");
  });

  content.querySelectorAll(".quote-swiper-button").forEach((button) => {
    button.remove();
  });

  let progressbar = content.querySelector(".quote-swiper-progressbar");

  if (!progressbar) {
    progressbar = document.createElement("div");
    progressbar.className = "quote-swiper-progressbar swiper-pagination";
    content.appendChild(progressbar);
  }

  return swiperEl;
}

function initQuoteSwiper(startIndex = 0) {
  const swiperEl = ensureQuoteSwiperStructure();
  const track = document.querySelector(".block_quote-popup-info-inner");
  const items = track ? track.querySelectorAll(".quote-item") : [];

  if (!swiperEl || !track || !items.length) {
    destroyQuoteSwiper();
    return;
  }

  if (typeof Swiper === "undefined") {
    console.warn("Swiper is not loaded. Please include Swiper JS/CSS before quote popup JS.");
    return;
  }

  destroyQuoteSwiper();

  quoteBasketSwiper = new Swiper(swiperEl, {
    slidesPerView: 1.15,
    spaceBetween: 16,
    speed: 350,
    watchOverflow: true,
    observer: true,
    observeParents: true,

    pagination: {
      el: ".quote-swiper-progressbar",
      type: "progressbar"
    },

    breakpoints: {
      750: {
        slidesPerView: 2.2,
        spaceBetween: 20
      },
      990: {
        slidesPerView: 3.2,
        spaceBetween: 24
      },
      1200: {
        slidesPerView: 4.5,
        spaceBetween: 28
      }
    }
  });

  quoteBasketSwiper.slideTo(Math.max(0, Math.min(startIndex, items.length - 1)), 0);
}

function updateQuoteSwiper() {
  if (quoteBasketSwiper && typeof quoteBasketSwiper.update === "function") {
    quoteBasketSwiper.update();
  }
}

function normalizeRenderedQuoteDimensionSummaries(container) {
  if (!container) return;

  container.querySelectorAll('.quote-option--summary').forEach((node) => {
    const cleanValue = cleanText(node.textContent);
    const formattedValue = formatNumericVariantDimensions(cleanValue);

    if (/^\d+(?:\.\d+)?"L\s*\/\s*\d+(?:\.\d+)?"W\s*\/\s*\d+(?:\.\d+)?"H$/i.test(formattedValue)) {
      node.textContent = formattedValue;
    }
  });
}

window.addEventListener("resize", function () {
  updateQuoteSwiper();
});

/* =========================
   RENDER
========================= */
function renderQuoteBasket() {
  const container = document.querySelector(".block_quote-popup-info-inner");
  if (!container) return;

  let items = getQuoteItems();
  const currentSwiperIndex = getQuoteSwiperIndex();

  if (items.length === 0) {
    container.innerHTML = '<p class="quote-empty">Your quote basket is empty.</p>';
    updateQuoteCount();
    destroyQuoteSwiper();
    return;
  }

  destroyQuoteSwiper();

  let html = items
    .map((item, index) => {
      const isLinkedItem = isLinkedQuoteItem(item);
      const imageHtml = item.image
        ? `<div class="quote-img-frame"><img src="${escapeHtml(item.image)}" class="quote-img" alt="${escapeHtml(item.product_title)}"></div>`
        : `<div class="quote-img-frame"><div class="quote-img quote-img--placeholder" aria-hidden="true"></div></div>`;
      const quantityHtml = isLinkedItem
        ? `<div class="quote-qty quote-qty--linked"><span>${item.qty}</span></div>`
        : `<div class="quote-qty">
              <button type="button" class="qty-minus" aria-label="Decrease quantity">-</button>
              <span>${item.qty}</span>
              <button type="button" class="qty-plus" aria-label="Increase quantity">+</button>
            </div>`;
      const removeButtonHtml = `<button type="button" class="quote-remove-item" aria-label="Remove item">${getQuoteRemoveIconHtml()}</button>`;
      const instanceId = ensureQuoteItemInstanceId(item);

      return `
        <div class="quote-item${isLinkedItem ? " quote-item--linked" : ""}" data-index="${index}" data-instance-id="${escapeHtml(instanceId)}">
          ${imageHtml}

          <div class="quote-info">
            <div class="quote-title">${escapeHtml(item.product_title)}</div>
            ${renderItemDetails(item, index)}

            <div class="quote-item-actions">
              ${quantityHtml}
              ${removeButtonHtml}
            </div>
          </div>
        </div>
      `;
    })
    .join("");

  container.innerHTML = html;
  normalizeRenderedQuoteDimensionSummaries(container);

  updateQuoteCount();
  initQuoteSwiper(currentSwiperIndex);
}

/* =========================
   ACTIONS
========================= */
function handleAddQuoteButtonClick(e) {
  const addBtn = e.target.closest(".new-buy-quote-button, [data-secondary-card-quote-button], .block__secondary-card-product__button--quote");

  if (!addBtn || e.__customQuoteAddHandled) {
    return false;
  }

  e.__customQuoteAddHandled = true;
  e.preventDefault();

  if (addBtn.getAttribute("data-request-quote-product") === "false") {
    return true;
  }

  if (!validateCustomDimensionsForQuote(e)) {
    return true;
  }

  if (addBtn.matches("[data-secondary-card-quote-button], .block__secondary-card-product__button--quote")) {
    addCardProductToQuote(addBtn);
  } else {
    addCurrentProductToQuote(addBtn);
  }

  return true;
}

document.addEventListener("click", handleAddQuoteButtonClick, true);

document.addEventListener("click", function (e) {
  if (handleAddQuoteButtonClick(e)) return;

  const moreBtn = e.target.closest(".quote-more-toggle");

  if (moreBtn) {
    const index = moreBtn.dataset.index;
    const content = document.querySelector(`.quote-more-content[data-index="${index}"]`);

    if (content) {
      const isHidden = content.hasAttribute("hidden");

      if (isHidden) {
        content.removeAttribute("hidden");
      } else {
        content.setAttribute("hidden", "");
      }

      moreBtn.outerHTML = getToggleButtonHtml(index, isHidden);
      updateQuoteSwiper();
    }

    return;
  }

  const itemEl = e.target.closest(".quote-item");
  if (!itemEl) return;

  let items = getQuoteItems();
  const instanceId = cleanText(itemEl.getAttribute("data-instance-id"));
  let index = Number(itemEl.dataset.index);
  if (instanceId) {
    const instanceIndex = items.findIndex((item) => cleanText(item && item.properties && item.properties._quote_instance_id) === instanceId);
    if (instanceIndex > -1) index = instanceIndex;
  }

  if (!items[index]) return;

  if (e.target.closest(".quote-remove-item")) {
    items = removeQuoteItem(items, index);
    setQuoteItems(items);
    renderQuoteBasket();
    return;
  }

  if (e.target.closest(".qty-plus")) {
    items = updateQuoteItemQuantity(items, index, 1);
  }

  if (e.target.closest(".qty-minus")) {
    items = updateQuoteItemQuantity(items, index, -1);
  }

  setQuoteItems(items);
  renderQuoteBasket();
});

/* =========================
   HIDDEN PROPERTY EVENTS
========================= */
document.addEventListener("change", function (event) {
  setActiveQuoteFormFromElement(event.target);

  if (
    event.target.matches(".color-option[data-custom-color-media]") ||
    event.target.matches(".block-color-texture-card__texture-item input") ||
    event.target.matches(".color-dependent-option input") ||
    event.target.matches("[data-decide-later-input='true']")
  ) {
    markExplicitQuoteImageSelection(event.target);
  }

  if (
    event.target.matches(".custom-option-radio") ||
    event.target.matches(".color-option") ||
    event.target.matches('[name^="properties["]')
  ) {
    scheduleHiddenPropertiesUpdate();
  }
});

document.addEventListener("click", function (event) {
  setActiveQuoteFormFromElement(event.target);

  if (
    event.target.closest("label") ||
    event.target.closest(".block-color-texture-card") ||
    event.target.closest(".block-standard-option") ||
    event.target.closest(".block-addon-option")
  ) {
    scheduleHiddenPropertiesUpdate();
  }
});

document.addEventListener("shopify:section:load", function () {
  scheduleHiddenPropertiesUpdate();
});

document.addEventListener("variant:change", function () {
  scheduleHiddenPropertiesUpdate();
});

document.addEventListener("product:variant-change", function () {
  scheduleHiddenPropertiesUpdate();
});

/* =========================
   INIT
========================= */
document.addEventListener("DOMContentLoaded", () => {
  scheduleHiddenPropertiesUpdate();
  updateQuoteCount();

  if (getQuoteItems().length > 0) {
    renderQuoteBasket();
  }

  initQuoteSwiper();
});
})();
